
/** This file has been generated. If you see errors or missing parameters, don't change this file. Instead, fix generate_aware_parameters_specification_from_json.js and regenerate it. */
export const awareParamSpec = {
    "min_flow_setpoint": {
        "id": "min_flow_setpoint",
        "param_no": 10004,
        "parent": 2000,
        "name": "Min Flow Setpoint",
        "name_orig": "Min Flow Setpoint",
        "desc": "The minimum percentage value that can be requested during normal operation. The value is a percentage of the configured nominal max. flow.",
        "type": "decimal",
        "min": "30.0",
        "max": "60.0",
        "res": "",
        "default": "30.0",
        "unit": "%",
        "options": ""
    },
    "max_flow_setpoint": {
        "id": "max_flow_setpoint",
        "param_no": 10005,
        "parent": 2000,
        "name": "Max Flow Setpoint",
        "name_orig": "Max Flow Setpoint",
        "desc": "The maximum percentage value that can be requested during normal operation. The value is a percentage of the configured nominal max. flow.",
        "type": "decimal",
        "min": "70.0",
        "max": "100.0",
        "res": "",
        "default": "100.0",
        "unit": "%",
        "options": ""
    },
    "summer_period_trt_heating": {
        "id": "summer_period_trt_heating",
        "param_no": 10274,
        "parent": 3000,
        "name": "Summer period trt heating",
        "name_orig": "Summer period trt heating",
        "desc": "Setpoint for heating during the defined summer period. If the room temperature gets below this value the unit will start heating.",
        "type": "decimal",
        "min": "0.0",
        "max": "30.0",
        "res": "",
        "default": "22.0",
        "unit": "°C",
        "options": ""
    },
    "summer_period_trt_cooling": {
        "id": "summer_period_trt_cooling",
        "param_no": 10275,
        "parent": 3000,
        "name": "Summer period trt cooling",
        "name_orig": "Summer period trt cooling",
        "desc": "Setpoint for cooling during the defined summer period. If the room temperature gets above this value the unit will start cooling.",
        "type": "decimal",
        "min": "0.0",
        "max": "30.0",
        "res": "",
        "default": "24.0",
        "unit": "°C",
        "options": ""
    },
    "summer_period_active_cooling_allowed": {
        "id": "summer_period_active_cooling_allowed",
        "param_no": 10276,
        "parent": 3000,
        "name": "Summer period active cooling allowed",
        "name_orig": "Summer period active cooling allowed",
        "desc": "True: The unit is allowed to use the heat pump when cooling.  False: The unit is not allowed to use the heat pump to cool the room. This means only outside air (free cooling) can be used for this purpose.",
        "type": "bool",
        "min": "0",
        "max": "0",
        "res": "",
        "default": "False",
        "unit": "-",
        "options": ""
    },
    "summer_period_active_heating_allowed": {
        "id": "summer_period_active_heating_allowed",
        "param_no": 10277,
        "parent": 3000,
        "name": "Summer period active heating allowed",
        "name_orig": "Summer period active heating allowed",
        "desc": "True: The unit is allowed to use the heat pump and the electric heaters to heat the room.  False: The unit is not allowed to use the heat pump and the electric heaters to heat the room. This means only traditional, passive heat exchanger can be used for this purpose.",
        "type": "bool",
        "min": "0",
        "max": "0",
        "res": "",
        "default": "False",
        "unit": "-",
        "options": ""
    },
    "summer_period_start_date": {
        "id": "summer_period_start_date",
        "param_no": 10278,
        "parent": 3000,
        "name": "Summer period start date",
        "name_orig": "Summer period start date",
        "desc": "Date that defines the start of the summer period, where the unit operates according to the summer period parameters.  The date is formatted as MMDD.",
        "type": "int",
        "min": "101",
        "max": "801",
        "res": "",
        "default": "501",
        "unit": "-",
        "options": ""
    },
    "summer_period_max_rqt": {
        "id": "summer_period_max_rqt",
        "param_no": 10279,
        "parent": 3000,
        "name": "Summer period max. requested inlet temp",
        "name_orig": "Summer period max. requested inlet temp",
        "desc": "The maximum inlet temperature the controls can request when using the summer period parameters.  Changes to the default value will affect the unit's thermal control and performance.",
        "type": "decimal",
        "min": "30.0",
        "max": "50.0",
        "res": "",
        "default": "40.0",
        "unit": "°C",
        "options": ""
    },
    "summer_period_min_rqt": {
        "id": "summer_period_min_rqt",
        "param_no": 10280,
        "parent": 3000,
        "name": "Summer period min. requested inlet temp",
        "name_orig": "Summer period min. requested inlet temp",
        "desc": "The minimum inlet temperature the controls can request when using the summer period parameters.  Changes to the default value will affect the unit's thermal control and performance.",
        "type": "decimal",
        "min": "0.0",
        "max": "20.0",
        "res": "",
        "default": "5.0",
        "unit": "°C",
        "options": ""
    },
    "winter_period_trt_heating": {
        "id": "winter_period_trt_heating",
        "param_no": 10281,
        "parent": 4000,
        "name": "Winter period trt heating",
        "name_orig": "Winter period trt heating",
        "desc": "Setpoint for heating during the defined winter period. If the room temperature gets below this value the unit will start heating.",
        "type": "decimal",
        "min": "0.0",
        "max": "30.0",
        "res": "",
        "default": "22.0",
        "unit": "°C",
        "options": ""
    },
    "winter_period_trt_cooling": {
        "id": "winter_period_trt_cooling",
        "param_no": 10282,
        "parent": 4000,
        "name": "Winter period trt cooling",
        "name_orig": "Winter period trt cooling",
        "desc": "Setpoint for cooling during the defined winter period. If the room temperature gets above this value the unit will start cooling.",
        "type": "decimal",
        "min": "0.0",
        "max": "30.0",
        "res": "",
        "default": "24.0",
        "unit": "°C",
        "options": ""
    },
    "winter_period_active_cooling_allowed": {
        "id": "winter_period_active_cooling_allowed",
        "param_no": 10283,
        "parent": 4000,
        "name": "Winter period active cooling allowed",
        "name_orig": "Winter period active cooling allowed",
        "desc": "True: The unit is allowed to use the heat pump when cooling.  False: The unit is not allowed to use the heat pump to cool the room. This means only outside air (free cooling) can be used for this purpose.",
        "type": "bool",
        "min": "0",
        "max": "0",
        "res": "",
        "default": "False",
        "unit": "-",
        "options": ""
    },
    "winter_period_active_heating_allowed": {
        "id": "winter_period_active_heating_allowed",
        "param_no": 10284,
        "parent": 4000,
        "name": "Winter period active heating allowed",
        "name_orig": "Winter period active heating allowed",
        "desc": "True: The unit is allowed to use the heat pump and the electric heaters to heat the room.  False: The unit is not allowed to use the heat pump and the electric heaters to heat the room. This means only traditional, passive heat exchanger can be used for this purpose.",
        "type": "bool",
        "min": "0",
        "max": "0",
        "res": "",
        "default": "False",
        "unit": "-",
        "options": ""
    },
    "winter_period_start_date": {
        "id": "winter_period_start_date",
        "param_no": 10285,
        "parent": 4000,
        "name": "Winter period start date",
        "name_orig": "Winter period start date",
        "desc": "Date that defines the start of the winter period, where the unit operates according to the winter period parameters.  The date is formatted as MMDD.",
        "type": "int",
        "min": "801",
        "max": "1231",
        "res": "",
        "default": "1001",
        "unit": "-",
        "options": ""
    },
    "winter_period_max_rqt": {
        "id": "winter_period_max_rqt",
        "param_no": 10286,
        "parent": 4000,
        "name": "Winter period max. requested inlet temp",
        "name_orig": "Winter period max. requested inlet temp",
        "desc": "The maximum inlet temperature the controls can request when using the winter period parameters.  Changes to the default value will affect the unit's thermal control and performance.",
        "type": "decimal",
        "min": "30.0",
        "max": "50.0",
        "res": "",
        "default": "40.0",
        "unit": "°C",
        "options": ""
    },
    "winter_period_min_rqt": {
        "id": "winter_period_min_rqt",
        "param_no": 10287,
        "parent": 4000,
        "name": "Winter period min. requested inlet temp",
        "name_orig": "Winter period min. requested inlet temp",
        "desc": "The minimum inlet temperature the controls can request when using the winter period parameters.  Changes to the default value will affect the unit's thermal control and performance.",
        "type": "decimal",
        "min": "0.0",
        "max": "20.0",
        "res": "",
        "default": "5.0",
        "unit": "°C",
        "options": ""
    },
    "co2_control_enabled": {
        "id": "co2_control_enabled",
        "param_no": 10008,
        "parent": 5000,
        "name": "CO2 Control Enabled",
        "name_orig": "CO2 Control Enabled",
        "desc": "True: CO2 levels are considered when the control algorithm calculates the unit airflow. False: CO2 levels are not considered when the control algorithm calculates the unit airflow.",
        "type": "bool",
        "min": "0",
        "max": "0",
        "res": "",
        "default": "False",
        "unit": "-",
        "options": ""
    },
    "co2_control_min": {
        "id": "co2_control_min",
        "param_no": 10009,
        "parent": 5000,
        "name": "CO2 Control Min",
        "name_orig": "CO2 Control Min",
        "desc": "The CO2 level, where the unit switches from \"recirculation\" to \"ventilation\".  A CO2 level 10% above this value will create a start signal that, if configured, starts the unit.  A CO2 level just below this value removes the start signal.",
        "type": "int",
        "min": "400",
        "max": "5000",
        "res": "",
        "default": "650",
        "unit": "ppm",
        "options": ""
    },
    "co2_control_max": {
        "id": "co2_control_max",
        "param_no": 10010,
        "parent": 5000,
        "name": "CO2 Control Max",
        "name_orig": "CO2 Control Max",
        "desc": "The CO2 level where the unit operates at max. airflow.",
        "type": "int",
        "min": "400",
        "max": "5000",
        "res": "",
        "default": "900",
        "unit": "ppm",
        "options": ""
    },
    "co2_control_multiple_sensor_mode": {
        "id": "co2_control_multiple_sensor_mode",
        "param_no": 10269,
        "parent": 5000,
        "name": "CO2 Control Multiple Sensor Mode",
        "name_orig": "CO2 Control Multiple Sensor Mode",
        "desc": "Mode for operating with more than one CO2 sensor",
        "type": "enum",
        "min": "0",
        "max": "3",
        "res": "",
        "default": "0",
        "unit": "-",
        "options": {
            "0": "Max - Including Internal Sensor",
            "1": "Max - External Sensors Only",
            "2": "Average - Including Internal Sensor",
            "3": "Average - External Sensors Only"
        }
    },
    "night_cooling_trt": {
        "id": "night_cooling_trt",
        "param_no": 10288,
        "parent": 6000,
        "name": "Night Cooling Target Room Temp",
        "name_orig": "Night Cooling Target Room Temp",
        "desc": "Room temperature setpoint when operating in night cooling. The unit will seek to cool the room to this temperature.",
        "type": "decimal",
        "min": "10.0",
        "max": "22.0",
        "res": "",
        "default": "18.0",
        "unit": "°C",
        "options": ""
    },
    "night_cooling_max_flow_scaling": {
        "id": "night_cooling_max_flow_scaling",
        "param_no": 10294,
        "parent": 6000,
        "name": "Night Cooling Max Flow Scaling",
        "name_orig": "Night Cooling Max Flow Scaling",
        "desc": "The percentage of the nominal airflow that can be requested during night cooling.  The unit can be configured to be more than 100% of the nominal airflow since the noise level is not a concern during night cooling. Maximum value is 150%.",
        "type": "decimal",
        "min": "80.0",
        "max": "150.0",
        "res": "",
        "default": "100.0",
        "unit": "%",
        "options": ""
    },
    "night_cooling_min_inlet_temp": {
        "id": "night_cooling_min_inlet_temp",
        "param_no": 10289,
        "parent": 6000,
        "name": "Night Cooling Min Inlet Temp",
        "name_orig": "Night Cooling Min Inlet Temp",
        "desc": "The minimum inlet temperature when night cooling is active.",
        "type": "decimal",
        "min": "4.0",
        "max": "20.0",
        "res": "",
        "default": "10.0",
        "unit": "°C",
        "options": ""
    },
    "night_cooling_min_temp_difference": {
        "id": "night_cooling_min_temp_difference",
        "param_no": 10290,
        "parent": 6000,
        "name": "Night Cooling Min Temp Difference",
        "name_orig": "Night Cooling Min Temp Difference",
        "desc": "The minimum difference between the room temperature and the outside temperature for passive night cooling to be active.",
        "type": "decimal",
        "min": "1.0",
        "max": "10.0",
        "res": "",
        "default": "3.0",
        "unit": "°C",
        "options": ""
    },
    "night_cooling_active_allowed": {
        "id": "night_cooling_active_allowed",
        "param_no": 10291,
        "parent": 6000,
        "name": "Active Night Cooling Allowed",
        "name_orig": "Active Night Cooling Allowed",
        "desc": "True: The unit is allowed to use the heat pump to cool the room when Night Cooling.  False: The unit is not allowed to use the heat pump to cool when Night Cooling. This means only the outside air (free cooling) is used when Night Cooling.  Active night cooling will only kick in 4 hours before the end of the night cooling schedule if free cooling is not enough to cool the room.",
        "type": "bool",
        "min": "0",
        "max": "0",
        "res": "",
        "default": "False",
        "unit": "-",
        "options": ""
    },
    "extern_start_delay_time": {
        "id": "extern_start_delay_time",
        "param_no": 10013,
        "parent": 8000,
        "name": "Extern Start Delay Time",
        "name_orig": "Extern Start Delay Time",
        "desc": "Time (in seconds) from when an external signal is registered until it activates the unit. For the unit to start up after the time delay, the signal must still be registered after the configured delay.",
        "type": "int",
        "min": "0",
        "max": "3600",
        "res": "",
        "default": "5",
        "unit": "s",
        "options": ""
    },
    "extern_start_afterrun_timer": {
        "id": "extern_start_afterrun_timer",
        "param_no": 10014,
        "parent": 8000,
        "name": "Extern Start Afterrun Timer",
        "name_orig": "Extern Start Afterrun Timer",
        "desc": "Time (in minutes) the signal will continue to be active, after last detection.",
        "type": "int",
        "min": "0",
        "max": "1440",
        "res": "",
        "default": "10",
        "unit": "min",
        "options": ""
    },
    "extern_start_auto_off_timer": {
        "id": "extern_start_auto_off_timer",
        "param_no": 10015,
        "parent": 8000,
        "name": "Extern Start Auto Off Timer",
        "name_orig": "Extern Start Auto Off Timer",
        "desc": "Time (in minutes) after which the external start signal is canceled even though the physical is still present.",
        "type": "int",
        "min": "0",
        "max": "1440",
        "res": "",
        "default": "480",
        "unit": "min",
        "options": ""
    },
    "motion_start_delay_time": {
        "id": "motion_start_delay_time",
        "param_no": 10271,
        "parent": 9000,
        "name": "Motion Start Delay Time",
        "name_orig": "Motion Start Delay Time",
        "desc": "Time (in seconds) from when a movement is registered until the unit is activated.  For the unit to activate after the time delay, movement must still be registered in the room.",
        "type": "int",
        "min": "0",
        "max": "3600",
        "res": "",
        "default": "5",
        "unit": "s",
        "options": ""
    },
    "motion_afterrun_timer": {
        "id": "motion_afterrun_timer",
        "param_no": 10270,
        "parent": 9000,
        "name": "Motion Afterrun Timer",
        "name_orig": "Motion Afterrun Timer",
        "desc": "Time (in minutes) from when movement was last registered until the the movement start signal is canceled and the unit stops if there are no other active start signals.",
        "type": "int",
        "min": "0",
        "max": "1440",
        "res": "",
        "default": "30",
        "unit": "min",
        "options": ""
    },
    "start_priority_1": {
        "id": "start_priority_1",
        "param_no": 10022,
        "parent": 10000,
        "name": "Start priority 1",
        "name_orig": "Start priority 1",
        "desc": "A Start Priority tells you how the unit will start up. The priority goes from 1-6 where the smallest number has the highest priority.",
        "type": "enum",
        "min": "0",
        "max": "7",
        "res": "",
        "default": "6",
        "unit": "-",
        "options": {
            "0": "None",
            "1": "External Start",
            "2": "Motion Sensor",
            "5": "CO2 Sensor",
            "6": "Timer",
            "7": "Modbus"
        }
    },
    "start_priority_2": {
        "id": "start_priority_2",
        "param_no": 10023,
        "parent": 10000,
        "name": "Start priority 2",
        "name_orig": "Start priority 2",
        "desc": "A Start Priority tells you how the unit will start up. The priority goes from 1-6 where the smallest number has the highest priority.",
        "type": "enum",
        "min": "0",
        "max": "7",
        "res": "",
        "default": "0",
        "unit": "-",
        "options": {
            "0": "None",
            "1": "External Start",
            "2": "Motion Sensor",
            "5": "CO2 Sensor",
            "6": "Timer",
            "7": "Modbus"
        }
    },
    "start_priority_3": {
        "id": "start_priority_3",
        "param_no": 10024,
        "parent": 10000,
        "name": "Start priority 3",
        "name_orig": "Start priority 3",
        "desc": "A Start Priority tells you how the unit will start up. The priority goes from 1-6 where the smallest number has the highest priority.",
        "type": "enum",
        "min": "0",
        "max": "7",
        "res": "",
        "default": "0",
        "unit": "-",
        "options": {
            "0": "None",
            "1": "External Start",
            "2": "Motion Sensor",
            "5": "CO2 Sensor",
            "6": "Timer",
            "7": "Modbus"
        }
    },
    "start_priority_4": {
        "id": "start_priority_4",
        "param_no": 10025,
        "parent": 10000,
        "name": "Start priority 4",
        "name_orig": "Start priority 4",
        "desc": "A Start Priority tells you how the unit will start up. The priority goes from 1-6 where the smallest number has the highest priority.",
        "type": "enum",
        "min": "0",
        "max": "7",
        "res": "",
        "default": "0",
        "unit": "-",
        "options": {
            "0": "None",
            "1": "External Start",
            "2": "Motion Sensor",
            "5": "CO2 Sensor",
            "6": "Timer",
            "7": "Modbus"
        }
    },
    "start_priority_5": {
        "id": "start_priority_5",
        "param_no": 10026,
        "parent": 10000,
        "name": "Start priority 5",
        "name_orig": "Start priority 5",
        "desc": "A Start Priority tells you how the unit will start up. The priority goes from 1-6 where the smallest number has the highest priority.",
        "type": "enum",
        "min": "0",
        "max": "7",
        "res": "",
        "default": "0",
        "unit": "-",
        "options": {
            "0": "None",
            "1": "External Start",
            "2": "Motion Sensor",
            "5": "CO2 Sensor",
            "6": "Timer",
            "7": "Modbus"
        }
    },
    "start_priority_6": {
        "id": "start_priority_6",
        "param_no": 10027,
        "parent": 10000,
        "name": "Start priority 6",
        "name_orig": "Start priority 6",
        "desc": "A Start Priority tells you how the unit will start up. The priority goes from 1-6 where the smallest number has the highest priority.",
        "type": "enum",
        "min": "0",
        "max": "7",
        "res": "",
        "default": "0",
        "unit": "-",
        "options": {
            "0": "None",
            "1": "External Start",
            "2": "Motion Sensor",
            "5": "CO2 Sensor",
            "6": "Timer",
            "7": "Modbus"
        }
    },
    "start_priority_dependency": {
        "id": "start_priority_dependency",
        "param_no": 10028,
        "parent": 10000,
        "name": "Start Priority Dependency",
        "name_orig": "Start Priority Dependency",
        "desc": "True: The start priorities are dependent on each other.  False: The start priorities are independent of each other.",
        "type": "bool",
        "min": "0",
        "max": "0",
        "res": "",
        "default": "False",
        "unit": "-",
        "options": ""
    },
    "timer_schedule_0_enabled": {
        "id": "timer_schedule_0_enabled",
        "param_no": 10206,
        "parent": 12000,
        "name": "Timer Schedule 0 Enabled",
        "name_orig": "Timer Schedule 0 Enabled",
        "desc": "True: Schedule is active. False: Schedule is not active.",
        "type": "bool",
        "min": "0",
        "max": "0",
        "res": "",
        "default": "False",
        "unit": "-",
        "options": ""
    },
    "timer_schedule_0_mode": {
        "id": "timer_schedule_0_mode",
        "param_no": 10207,
        "parent": 12000,
        "name": "Timer Schedule 0 Mode",
        "name_orig": "Timer Schedule 0 Mode",
        "desc": "Operation mode which the schedule operates according to.",
        "type": "enum",
        "min": "1",
        "max": "2",
        "res": "",
        "default": "1",
        "unit": "-",
        "options": {
            "1": "Comfort",
            "2": "Night Cooling"
        }
    },
    "timer_schedule_0_days": {
        "id": "timer_schedule_0_days",
        "param_no": 10208,
        "parent": 12000,
        "name": "Timer Schedule 0 Days",
        "name_orig": "Timer Schedule 0 Days",
        "desc": "This number sets which days the schedule runs. Each day has a value: Mon=1, Tue=2, Wed=4, Thu=8, Fri=16, Sat=32, Sun=64. Add the values for the days you want. For example, if you want the schedule active Monday to Friday, you add 1+2+4+8+16 = 31. If you want only weekends, 32+64 = 96. Use this number to choose the days the schedule should be active.",
        "type": "int",
        "min": "0",
        "max": "127",
        "res": "",
        "default": "0",
        "unit": "-",
        "options": ""
    },
    "timer_schedule_0_start_time": {
        "id": "timer_schedule_0_start_time",
        "param_no": 10209,
        "parent": 12000,
        "name": "Timer Schedule 0 Start Time",
        "name_orig": "Timer Schedule 0 Start Time",
        "desc": "Time when the schedule starts in minutes. If Start Time = 420 the schedule starts at 07.00 AM (420 : 60 = 7).",
        "type": "int",
        "min": "0",
        "max": "1439",
        "res": "",
        "default": "0",
        "unit": "min",
        "options": ""
    },
    "timer_schedule_0_duration": {
        "id": "timer_schedule_0_duration",
        "param_no": 10210,
        "parent": 12000,
        "name": "Timer Schedule 0 Duration",
        "name_orig": "Timer Schedule 0 Duration",
        "desc": "Duration of the schedule in minutes. If Duration = 600 the schedule runs for 10 hours from when is has started (600 : 60 = 10).",
        "type": "int",
        "min": "0",
        "max": "1439",
        "res": "",
        "default": "0",
        "unit": "min",
        "options": ""
    },
    "timer_schedule_1_enabled": {
        "id": "timer_schedule_1_enabled",
        "param_no": 10195,
        "parent": 13000,
        "name": "Timer Schedule 1 Enabled",
        "name_orig": "Timer Schedule 1 Enabled",
        "desc": "True: Schedule is active. False: Schedule is not active.",
        "type": "bool",
        "min": "0",
        "max": "0",
        "res": "",
        "default": "True",
        "unit": "-",
        "options": ""
    },
    "timer_schedule_1_mode": {
        "id": "timer_schedule_1_mode",
        "param_no": 10034,
        "parent": 13000,
        "name": "Timer Schedule 1 Mode",
        "name_orig": "Timer Schedule 1 Mode",
        "desc": "Operation mode which the schedule operates according to.",
        "type": "enum",
        "min": "1",
        "max": "2",
        "res": "",
        "default": "1",
        "unit": "-",
        "options": {
            "1": "Comfort",
            "2": "Night Cooling"
        }
    },
    "timer_schedule_1_days": {
        "id": "timer_schedule_1_days",
        "param_no": 10035,
        "parent": 13000,
        "name": "Timer Schedule 1 Days",
        "name_orig": "Timer Schedule 1 Days",
        "desc": "This number sets which days the schedule runs. Each day has a value: Mon=1, Tue=2, Wed=4, Thu=8, Fri=16, Sat=32, Sun=64. Add the values for the days you want. For example, if you want the schedule active Monday to Friday, you add 1+2+4+8+16 = 31. If you want only weekends, 32+64 = 96. Use this number to choose the days the schedule should be active.",
        "type": "int",
        "min": "0",
        "max": "127",
        "res": "",
        "default": "127",
        "unit": "-",
        "options": ""
    },
    "timer_schedule_1_start_time": {
        "id": "timer_schedule_1_start_time",
        "param_no": 10036,
        "parent": 13000,
        "name": "Timer Schedule 1 Start Time",
        "name_orig": "Timer Schedule 1 Start Time",
        "desc": "Time when the schedule starts in minutes. If Start Time = 420 the schedule starts at 07.00 AM (420 : 60 = 7).",
        "type": "int",
        "min": "0",
        "max": "1439",
        "res": "",
        "default": "0",
        "unit": "min",
        "options": ""
    },
    "timer_schedule_1_duration": {
        "id": "timer_schedule_1_duration",
        "param_no": 10037,
        "parent": 13000,
        "name": "Timer Schedule 1 Duration",
        "name_orig": "Timer Schedule 1 Duration",
        "desc": "Duration of the schedule in minutes. If Duration = 600 the schedule runs for 10 hours from when is has started (600 : 60 = 10).",
        "type": "int",
        "min": "0",
        "max": "1439",
        "res": "",
        "default": "1439",
        "unit": "min",
        "options": ""
    },
    "timer_schedule_2_enabled": {
        "id": "timer_schedule_2_enabled",
        "param_no": 10196,
        "parent": 14000,
        "name": "Timer Schedule 2 Enabled",
        "name_orig": "Timer Schedule 2 Enabled",
        "desc": "True: Schedule is active. False: Schedule is not active.",
        "type": "bool",
        "min": "0",
        "max": "0",
        "res": "",
        "default": "False",
        "unit": "-",
        "options": ""
    },
    "timer_schedule_2_mode": {
        "id": "timer_schedule_2_mode",
        "param_no": 10040,
        "parent": 14000,
        "name": "Timer Schedule 2 Mode",
        "name_orig": "Timer Schedule 2 Mode",
        "desc": "Operation mode which the schedule operates according to.",
        "type": "enum",
        "min": "1",
        "max": "2",
        "res": "",
        "default": "1",
        "unit": "-",
        "options": {
            "1": "Comfort",
            "2": "Night Cooling"
        }
    },
    "timer_schedule_2_days": {
        "id": "timer_schedule_2_days",
        "param_no": 10041,
        "parent": 14000,
        "name": "Timer Schedule 2 Days",
        "name_orig": "Timer Schedule 2 Days",
        "desc": "This number sets which days the schedule runs. Each day has a value: Mon=1, Tue=2, Wed=4, Thu=8, Fri=16, Sat=32, Sun=64. Add the values for the days you want. For example, if you want the schedule active Monday to Friday, you add 1+2+4+8+16 = 31. If you want only weekends, 32+64 = 96. Use this number to choose the days the schedule should be active.",
        "type": "int",
        "min": "0",
        "max": "127",
        "res": "",
        "default": "0",
        "unit": "-",
        "options": ""
    },
    "timer_schedule_2_start_time": {
        "id": "timer_schedule_2_start_time",
        "param_no": 10042,
        "parent": 14000,
        "name": "Timer Schedule 2 Start Time",
        "name_orig": "Timer Schedule 2 Start Time",
        "desc": "Time when the schedule starts in minutes. If Start Time = 420 the schedule starts at 07.00 AM (420 : 60 = 7).",
        "type": "int",
        "min": "0",
        "max": "1439",
        "res": "",
        "default": "0",
        "unit": "min",
        "options": ""
    },
    "timer_schedule_2_duration": {
        "id": "timer_schedule_2_duration",
        "param_no": 10043,
        "parent": 14000,
        "name": "Timer Schedule 2 Duration",
        "name_orig": "Timer Schedule 2 Duration",
        "desc": "Duration of the schedule in minutes. If Duration = 600 the schedule runs for 10 hours from when is has started (600 : 60 = 10).",
        "type": "int",
        "min": "0",
        "max": "1439",
        "res": "",
        "default": "0",
        "unit": "min",
        "options": ""
    },
    "timer_schedule_3_enabled": {
        "id": "timer_schedule_3_enabled",
        "param_no": 10213,
        "parent": 15000,
        "name": "Timer Schedule 3 Enabled",
        "name_orig": "Timer Schedule 3 Enabled",
        "desc": "True: Schedule is active. False: Schedule is not active.",
        "type": "bool",
        "min": "0",
        "max": "0",
        "res": "",
        "default": "False",
        "unit": "-",
        "options": ""
    },
    "timer_schedule_3_mode": {
        "id": "timer_schedule_3_mode",
        "param_no": 10214,
        "parent": 15000,
        "name": "Timer Schedule 3 Mode",
        "name_orig": "Timer Schedule 3 Mode",
        "desc": "Operation mode which the schedule operates according to.",
        "type": "enum",
        "min": "1",
        "max": "2",
        "res": "",
        "default": "1",
        "unit": "-",
        "options": {
            "1": "Comfort",
            "2": "Night Cooling"
        }
    },
    "timer_schedule_3_days": {
        "id": "timer_schedule_3_days",
        "param_no": 10215,
        "parent": 15000,
        "name": "Timer Schedule 3 Days",
        "name_orig": "Timer Schedule 3 Days",
        "desc": "This number sets which days the schedule runs. Each day has a value: Mon=1, Tue=2, Wed=4, Thu=8, Fri=16, Sat=32, Sun=64. Add the values for the days you want. For example, if you want the schedule active Monday to Friday, you add 1+2+4+8+16 = 31. If you want only weekends, 32+64 = 96. Use this number to choose the days the schedule should be active.",
        "type": "int",
        "min": "0",
        "max": "127",
        "res": "",
        "default": "0",
        "unit": "-",
        "options": ""
    },
    "timer_schedule_3_start_time": {
        "id": "timer_schedule_3_start_time",
        "param_no": 10216,
        "parent": 15000,
        "name": "Timer Schedule 3 Start Time",
        "name_orig": "Timer Schedule 3 Start Time",
        "desc": "Time when the schedule starts in minutes. If Start Time = 420 the schedule starts at 07.00 AM (420 : 60 = 7).",
        "type": "int",
        "min": "0",
        "max": "1439",
        "res": "",
        "default": "0",
        "unit": "min",
        "options": ""
    },
    "timer_schedule_3_duration": {
        "id": "timer_schedule_3_duration",
        "param_no": 10217,
        "parent": 15000,
        "name": "Timer Schedule 3 Duration",
        "name_orig": "Timer Schedule 3 Duration",
        "desc": "Duration of the schedule in minutes. If Duration = 600 the schedule runs for 10 hours from when is has started (600 : 60 = 10).",
        "type": "int",
        "min": "0",
        "max": "1439",
        "res": "",
        "default": "0",
        "unit": "min",
        "options": ""
    },
    "timer_schedule_4_enabled": {
        "id": "timer_schedule_4_enabled",
        "param_no": 10220,
        "parent": 16000,
        "name": "Timer Schedule 4 Enabled",
        "name_orig": "Timer Schedule 4 Enabled",
        "desc": "True: Schedule is active. False: Schedule is not active.",
        "type": "bool",
        "min": "0",
        "max": "0",
        "res": "",
        "default": "False",
        "unit": "-",
        "options": ""
    },
    "timer_schedule_4_mode": {
        "id": "timer_schedule_4_mode",
        "param_no": 10221,
        "parent": 16000,
        "name": "Timer Schedule 4 Mode",
        "name_orig": "Timer Schedule 4 Mode",
        "desc": "Operation mode which the schedule operates according to.",
        "type": "enum",
        "min": "1",
        "max": "2",
        "res": "",
        "default": "1",
        "unit": "-",
        "options": {
            "1": "Comfort",
            "2": "Night Cooling"
        }
    },
    "timer_schedule_4_days": {
        "id": "timer_schedule_4_days",
        "param_no": 10222,
        "parent": 16000,
        "name": "Timer Schedule 4 Days",
        "name_orig": "Timer Schedule 4 Days",
        "desc": "This number sets which days the schedule runs. Each day has a value: Mon=1, Tue=2, Wed=4, Thu=8, Fri=16, Sat=32, Sun=64. Add the values for the days you want. For example, if you want the schedule active Monday to Friday, you add 1+2+4+8+16 = 31. If you want only weekends, 32+64 = 96. Use this number to choose the days the schedule should be active.",
        "type": "int",
        "min": "0",
        "max": "127",
        "res": "",
        "default": "0",
        "unit": "-",
        "options": ""
    },
    "timer_schedule_4_start_time": {
        "id": "timer_schedule_4_start_time",
        "param_no": 10223,
        "parent": 16000,
        "name": "Timer Schedule 4 Start Time",
        "name_orig": "Timer Schedule 4 Start Time",
        "desc": "Time when the schedule starts in minutes. If Start Time = 420 the schedule starts at 07.00 AM (420 : 60 = 7).",
        "type": "int",
        "min": "0",
        "max": "1439",
        "res": "",
        "default": "0",
        "unit": "min",
        "options": ""
    },
    "timer_schedule_4_duration": {
        "id": "timer_schedule_4_duration",
        "param_no": 10224,
        "parent": 16000,
        "name": "Timer Schedule 4 Duration",
        "name_orig": "Timer Schedule 4 Duration",
        "desc": "Duration of the schedule in minutes. If Duration = 600 the schedule runs for 10 hours from when is has started (600 : 60 = 10).",
        "type": "int",
        "min": "0",
        "max": "1439",
        "res": "",
        "default": "0",
        "unit": "min",
        "options": ""
    },
    "timer_schedule_5_enabled": {
        "id": "timer_schedule_5_enabled",
        "param_no": 10227,
        "parent": 17000,
        "name": "Timer Schedule 5 Enabled",
        "name_orig": "Timer Schedule 5 Enabled",
        "desc": "True: Schedule is active. False: Schedule is not active.",
        "type": "bool",
        "min": "0",
        "max": "0",
        "res": "",
        "default": "False",
        "unit": "-",
        "options": ""
    },
    "timer_schedule_5_mode": {
        "id": "timer_schedule_5_mode",
        "param_no": 10228,
        "parent": 17000,
        "name": "Timer Schedule 5 Mode",
        "name_orig": "Timer Schedule 5 Mode",
        "desc": "Operation mode which the schedule operates according to.",
        "type": "enum",
        "min": "1",
        "max": "2",
        "res": "",
        "default": "1",
        "unit": "-",
        "options": {
            "1": "Comfort",
            "2": "Night Cooling"
        }
    },
    "timer_schedule_5_days": {
        "id": "timer_schedule_5_days",
        "param_no": 10229,
        "parent": 17000,
        "name": "Timer Schedule 5 Days",
        "name_orig": "Timer Schedule 5 Days",
        "desc": "This number sets which days the schedule runs. Each day has a value: Mon=1, Tue=2, Wed=4, Thu=8, Fri=16, Sat=32, Sun=64. Add the values for the days you want. For example, if you want the schedule active Monday to Friday, you add 1+2+4+8+16 = 31. If you want only weekends, 32+64 = 96. Use this number to choose the days the schedule should be active.",
        "type": "int",
        "min": "0",
        "max": "127",
        "res": "",
        "default": "0",
        "unit": "-",
        "options": ""
    },
    "timer_schedule_5_start_time": {
        "id": "timer_schedule_5_start_time",
        "param_no": 10230,
        "parent": 17000,
        "name": "Timer Schedule 5 Start Time",
        "name_orig": "Timer Schedule 5 Start Time",
        "desc": "Time when the schedule starts in minutes. If Start Time = 420 the schedule starts at 07.00 AM (420 : 60 = 7).",
        "type": "int",
        "min": "0",
        "max": "1439",
        "res": "",
        "default": "0",
        "unit": "min",
        "options": ""
    },
    "timer_schedule_5_duration": {
        "id": "timer_schedule_5_duration",
        "param_no": 10231,
        "parent": 17000,
        "name": "Timer Schedule 5 Duration",
        "name_orig": "Timer Schedule 5 Duration",
        "desc": "Duration of the schedule in minutes. If Duration = 600 the schedule runs for 10 hours from when is has started (600 : 60 = 10).",
        "type": "int",
        "min": "0",
        "max": "1439",
        "res": "",
        "default": "0",
        "unit": "min",
        "options": ""
    },
    "timer_schedule_6_enabled": {
        "id": "timer_schedule_6_enabled",
        "param_no": 10234,
        "parent": 18000,
        "name": "Timer Schedule 6 Enabled",
        "name_orig": "Timer Schedule 6 Enabled",
        "desc": "True: Schedule is active. False: Schedule is not active.",
        "type": "bool",
        "min": "0",
        "max": "0",
        "res": "",
        "default": "False",
        "unit": "-",
        "options": ""
    },
    "timer_schedule_6_mode": {
        "id": "timer_schedule_6_mode",
        "param_no": 10235,
        "parent": 18000,
        "name": "Timer Schedule 6 Mode",
        "name_orig": "Timer Schedule 6 Mode",
        "desc": "Operation mode which the schedule operates according to.",
        "type": "enum",
        "min": "1",
        "max": "2",
        "res": "",
        "default": "1",
        "unit": "-",
        "options": {
            "1": "Comfort",
            "2": "Night Cooling"
        }
    },
    "timer_schedule_6_days": {
        "id": "timer_schedule_6_days",
        "param_no": 10236,
        "parent": 18000,
        "name": "Timer Schedule 6 Days",
        "name_orig": "Timer Schedule 6 Days",
        "desc": "This number sets which days the schedule runs. Each day has a value: Mon=1, Tue=2, Wed=4, Thu=8, Fri=16, Sat=32, Sun=64. Add the values for the days you want. For example, if you want the schedule active Monday to Friday, you add 1+2+4+8+16 = 31. If you want only weekends, 32+64 = 96. Use this number to choose the days the schedule should be active.",
        "type": "int",
        "min": "0",
        "max": "127",
        "res": "",
        "default": "0",
        "unit": "-",
        "options": ""
    },
    "timer_schedule_6_start_time": {
        "id": "timer_schedule_6_start_time",
        "param_no": 10237,
        "parent": 18000,
        "name": "Timer Schedule 6 Start Time",
        "name_orig": "Timer Schedule 6 Start Time",
        "desc": "Time when the schedule starts in minutes. If Start Time = 420 the schedule starts at 07.00 AM (420 : 60 = 7).",
        "type": "int",
        "min": "0",
        "max": "1439",
        "res": "",
        "default": "0",
        "unit": "min",
        "options": ""
    },
    "timer_schedule_6_duration": {
        "id": "timer_schedule_6_duration",
        "param_no": 10238,
        "parent": 18000,
        "name": "Timer Schedule 6 Duration",
        "name_orig": "Timer Schedule 6 Duration",
        "desc": "Duration of the schedule in minutes. If Duration = 600 the schedule runs for 10 hours from when is has started (600 : 60 = 10).",
        "type": "int",
        "min": "0",
        "max": "1439",
        "res": "",
        "default": "0",
        "unit": "min",
        "options": ""
    },
    "timer_schedule_7_enabled": {
        "id": "timer_schedule_7_enabled",
        "param_no": 10241,
        "parent": 19000,
        "name": "Timer Schedule 7 Enabled",
        "name_orig": "Timer Schedule 7 Enabled",
        "desc": "True: Schedule is active. False: Schedule is not active.",
        "type": "bool",
        "min": "0",
        "max": "0",
        "res": "",
        "default": "False",
        "unit": "-",
        "options": ""
    },
    "timer_schedule_7_mode": {
        "id": "timer_schedule_7_mode",
        "param_no": 10242,
        "parent": 19000,
        "name": "Timer Schedule 7 Mode",
        "name_orig": "Timer Schedule 7 Mode",
        "desc": "Operation mode which the schedule operates according to.",
        "type": "enum",
        "min": "1",
        "max": "2",
        "res": "",
        "default": "1",
        "unit": "-",
        "options": {
            "1": "Comfort",
            "2": "Night Cooling"
        }
    },
    "timer_schedule_7_days": {
        "id": "timer_schedule_7_days",
        "param_no": 10243,
        "parent": 19000,
        "name": "Timer Schedule 7 Days",
        "name_orig": "Timer Schedule 7 Days",
        "desc": "This number sets which days the schedule runs. Each day has a value: Mon=1, Tue=2, Wed=4, Thu=8, Fri=16, Sat=32, Sun=64. Add the values for the days you want. For example, if you want the schedule active Monday to Friday, you add 1+2+4+8+16 = 31. If you want only weekends, 32+64 = 96. Use this number to choose the days the schedule should be active.",
        "type": "int",
        "min": "0",
        "max": "127",
        "res": "",
        "default": "0",
        "unit": "-",
        "options": ""
    },
    "timer_schedule_7_start_time": {
        "id": "timer_schedule_7_start_time",
        "param_no": 10244,
        "parent": 19000,
        "name": "Timer Schedule 7 Start Time",
        "name_orig": "Timer Schedule 7 Start Time",
        "desc": "Time when the schedule starts in minutes. If Start Time = 420 the schedule starts at 07.00 AM (420 : 60 = 7).",
        "type": "int",
        "min": "0",
        "max": "1439",
        "res": "",
        "default": "0",
        "unit": "min",
        "options": ""
    },
    "timer_schedule_7_duration": {
        "id": "timer_schedule_7_duration",
        "param_no": 10245,
        "parent": 19000,
        "name": "Timer Schedule 7 Duration",
        "name_orig": "Timer Schedule 7 Duration",
        "desc": "Duration of the schedule in minutes. If Duration = 600 the schedule runs for 10 hours from when is has started (600 : 60 = 10).",
        "type": "int",
        "min": "0",
        "max": "1439",
        "res": "",
        "default": "0",
        "unit": "min",
        "options": ""
    },
    "timer_schedule_8_enabled": {
        "id": "timer_schedule_8_enabled",
        "param_no": 10248,
        "parent": 20000,
        "name": "Timer Schedule 8 Enabled",
        "name_orig": "Timer Schedule 8 Enabled",
        "desc": "True: Schedule is active. False: Schedule is not active.",
        "type": "bool",
        "min": "0",
        "max": "0",
        "res": "",
        "default": "False",
        "unit": "-",
        "options": ""
    },
    "timer_schedule_8_mode": {
        "id": "timer_schedule_8_mode",
        "param_no": 10249,
        "parent": 20000,
        "name": "Timer Schedule 8 Mode",
        "name_orig": "Timer Schedule 8 Mode",
        "desc": "Operation mode which the schedule operates according to.",
        "type": "enum",
        "min": "1",
        "max": "2",
        "res": "",
        "default": "1",
        "unit": "-",
        "options": {
            "1": "Comfort",
            "2": "Night Cooling"
        }
    },
    "timer_schedule_8_days": {
        "id": "timer_schedule_8_days",
        "param_no": 10250,
        "parent": 20000,
        "name": "Timer Schedule 8 Days",
        "name_orig": "Timer Schedule 8 Days",
        "desc": "This number sets which days the schedule runs. Each day has a value: Mon=1, Tue=2, Wed=4, Thu=8, Fri=16, Sat=32, Sun=64. Add the values for the days you want. For example, if you want the schedule active Monday to Friday, you add 1+2+4+8+16 = 31. If you want only weekends, 32+64 = 96. Use this number to choose the days the schedule should be active.",
        "type": "int",
        "min": "0",
        "max": "127",
        "res": "",
        "default": "0",
        "unit": "-",
        "options": ""
    },
    "timer_schedule_8_start_time": {
        "id": "timer_schedule_8_start_time",
        "param_no": 10251,
        "parent": 20000,
        "name": "Timer Schedule 8 Start Time",
        "name_orig": "Timer Schedule 8 Start Time",
        "desc": "Time when the schedule starts in minutes. If Start Time = 420 the schedule starts at 07.00 AM (420 : 60 = 7).",
        "type": "int",
        "min": "0",
        "max": "1439",
        "res": "",
        "default": "0",
        "unit": "min",
        "options": ""
    },
    "timer_schedule_8_duration": {
        "id": "timer_schedule_8_duration",
        "param_no": 10252,
        "parent": 20000,
        "name": "Timer Schedule 8 Duration",
        "name_orig": "Timer Schedule 8 Duration",
        "desc": "Duration of the schedule in minutes. If Duration = 600 the schedule runs for 10 hours from when is has started (600 : 60 = 10).",
        "type": "int",
        "min": "0",
        "max": "1439",
        "res": "",
        "default": "0",
        "unit": "min",
        "options": ""
    },
    "time_zone": {
        "id": "time_zone",
        "param_no": 10046,
        "parent": 21000,
        "name": "Time Zone",
        "name_orig": "Time Zone",
        "desc": "The Time Zone where the unit is installed",
        "type": "string",
        "min": "0",
        "max": "0",
        "res": "",
        "default": "Europe/Copenhagen",
        "unit": "-",
        "options": ""
    },
    "unit_name": {
        "id": "unit_name",
        "param_no": 10194,
        "parent": 22000,
        "name": "Unit Name",
        "name_orig": "Unit Name",
        "desc": "The Unit name",
        "type": "string",
        "min": "0",
        "max": "0",
        "res": "",
        "default": "",
        "unit": "-",
        "options": ""
    },
    "forced_standby_time": {
        "id": "forced_standby_time",
        "param_no": 10302,
        "parent": 23000,
        "name": "Forced Standby Time",
        "name_orig": "Forced Standby Time",
        "desc": "Time in minutes before the unit goes to Standby mode when Forced Standby is activated. 0 = Disabled",
        "type": "int",
        "min": "0",
        "max": "1440",
        "res": "",
        "default": "300",
        "unit": "min",
        "options": ""
    },
    "boost_ventilation_mode_time": {
        "id": "boost_ventilation_mode_time",
        "param_no": 10303,
        "parent": 24000,
        "name": "Boost Ventilation Mode Time",
        "name_orig": "Boost Ventilation Mode Time",
        "desc": "The maximum time the \"Boost\" ventilation mode will be active before returning to \"Comfort\"",
        "type": "int",
        "min": "10",
        "max": "600",
        "res": "",
        "default": "30",
        "unit": "min",
        "options": ""
    },
    "low_noise_mode_time": {
        "id": "low_noise_mode_time",
        "param_no": 10304,
        "parent": 25000,
        "name": "Low Noise Mode Time",
        "name_orig": "Low Noise Mode Time",
        "desc": "The maximum time the \"Low Noise\" mode will be active before returning to \"Comfort\"",
        "type": "int",
        "min": "10",
        "max": "600",
        "res": "",
        "default": "60",
        "unit": "min",
        "options": ""
    },
    "manual_override_time": {
        "id": "manual_override_time",
        "param_no": 10067,
        "parent": 26000,
        "name": "Manual Override Time",
        "name_orig": "Manual Override Time",
        "desc": "The maximum time (in hours) the \"Manual\" mode will be active before returning to \"Comfort\"",
        "type": "int",
        "min": "1",
        "max": "99",
        "res": "",
        "default": "12",
        "unit": "hour",
        "options": ""
    },
    "min_temp_setpoint": {
        "id": "min_temp_setpoint",
        "param_no": 10006,
        "parent": 26000,
        "name": "Min Temp Setpoint",
        "name_orig": "Min Temp Setpoint",
        "desc": "The minimum temperature the setpoint can have, when being in \"Manual\" mode.",
        "type": "decimal",
        "min": "10.0",
        "max": "35.0",
        "res": "",
        "default": "18.0",
        "unit": "°C",
        "options": ""
    },
    "max_temp_setpoint": {
        "id": "max_temp_setpoint",
        "param_no": 10007,
        "parent": 26000,
        "name": "Max Temp Setpoint",
        "name_orig": "Max Temp Setpoint",
        "desc": "The maximum temperature the setpoint can have, when being in \"Manual\" mode.",
        "type": "decimal",
        "min": "10.0",
        "max": "35.0",
        "res": "",
        "default": "28.0",
        "unit": "°C",
        "options": ""
    },
    "cp_screen_lock_enabled_filter": {
        "id": "cp_screen_lock_enabled_filter",
        "param_no": 10296,
        "parent": 27000,
        "name": "CP Screen Lock Enabled for Filter Reset",
        "name_orig": "CP Screen Lock Enabled for Filter Reset",
        "desc": "True: The control panel screen lock will be enabled for filter reset, meaning that  filter reset through the control panel can only be performed by entering a PIN code. False: The control panel filter reset screen lock will be disabled.",
        "type": "bool",
        "min": "0",
        "max": "0",
        "res": "",
        "default": "True",
        "unit": "-",
        "options": ""
    },
    "cp_screen_lock_enabled_wifi_ap": {
        "id": "cp_screen_lock_enabled_wifi_ap",
        "param_no": 10297,
        "parent": 27000,
        "name": "CP Screen Lock Enabled Wi-Fi AP",
        "name_orig": "CP Screen Lock Enabled Wi-Fi AP",
        "desc": "True: The control panel screen lock will be enabled for Wi-Fi Access Point activation, meaning that Wi-Fi Access Point activation through the control panel can only be performed by entering a PIN code. False: The control panel Wi-Fi Access Point activation screen lock will be disabled.",
        "type": "bool",
        "min": "0",
        "max": "0",
        "res": "",
        "default": "True",
        "unit": "-",
        "options": ""
    },
    "cp_screen_lock_enabled_standby": {
        "id": "cp_screen_lock_enabled_standby",
        "param_no": 10298,
        "parent": 27000,
        "name": "CP Screen Lock Enabled for Standby",
        "name_orig": "CP Screen Lock Enabled for Standby",
        "desc": "True: The control panel screen lock will be enabled for Standby mode activation, meaning that Standby mode activation through the control panel can only be performed by entering a PIN code. False: The control panel Standby mode activation screen lock will be disabled.",
        "type": "bool",
        "min": "0",
        "max": "0",
        "res": "",
        "default": "True",
        "unit": "-",
        "options": ""
    },
    "cp_screen_lock_enabled_setpoints": {
        "id": "cp_screen_lock_enabled_setpoints",
        "param_no": 10337,
        "parent": 27000,
        "name": "CP Screen Lock Enabled for Setpoints",
        "name_orig": "CP Screen Lock Enabled for Setpoints",
        "desc": "True: The control panel screen lock will be enabled for Setpoints menu, meaning that Setpoints config through the control panel can only be performed by entering a PIN code. False: The control panel Setpoints menu screen lock will be disabled.",
        "type": "bool",
        "min": "0",
        "max": "0",
        "res": "",
        "default": "True",
        "unit": "-",
        "options": ""
    },
    "cp_screen_lock_enabled_reboot": {
        "id": "cp_screen_lock_enabled_reboot",
        "param_no": 10338,
        "parent": 27000,
        "name": "CP Screen Lock Enabled for Reboot",
        "name_orig": "CP Screen Lock Enabled for Reboot",
        "desc": "True: The control panel screen lock will be enabled for reboot, meaning that reboot through the control panel can only be performed by entering a PIN code. False: The control panel reboot screen lock will be disabled.",
        "type": "bool",
        "min": "0",
        "max": "0",
        "res": "",
        "default": "True",
        "unit": "-",
        "options": ""
    },
    "cp_screen_lock_pin_code": {
        "id": "cp_screen_lock_pin_code",
        "param_no": 10299,
        "parent": 27000,
        "name": "CP Screen Lock PIN Code",
        "name_orig": "CP Screen Lock PIN Code",
        "desc": "The PIN code used to unlock the control panel screen when the screen lock is enabled.",
        "type": "int",
        "min": "0",
        "max": "9999",
        "res": "",
        "default": "9732",
        "unit": "-",
        "options": ""
    },
    "cp_manual_mode_allowed": {
        "id": "cp_manual_mode_allowed",
        "param_no": 10300,
        "parent": 27000,
        "name": "CP Manual Mode Allowed",
        "name_orig": "CP Manual Mode Allowed",
        "desc": "True: Temperature can be pressed on the control panel and setpoint temporarily changed and thus Manual mode entered. False: Temperature cannot be pressed on the control panel and setpoint cannot be changed temporarily.",
        "type": "bool",
        "min": "0",
        "max": "0",
        "res": "",
        "default": "True",
        "unit": "-",
        "options": ""
    },
    "cp_flow_modes_allowed": {
        "id": "cp_flow_modes_allowed",
        "param_no": 10301,
        "parent": 27000,
        "name": "CP Flow Modes Allowed",
        "name_orig": "CP Flow Modes Allowed",
        "desc": "True: Flow can be pressed on the control panel and flow mode changed to 'Boost' or 'Low' temporarily. False: Flow cannot be pressed on the control panel and flow mode cannot be changed temporarily.",
        "type": "bool",
        "min": "0",
        "max": "0",
        "res": "",
        "default": "True",
        "unit": "-",
        "options": ""
    },
    "status_led_on_when_running_normal": {
        "id": "status_led_on_when_running_normal",
        "param_no": 10032,
        "parent": 28000,
        "name": "Status LED On When Running Normal",
        "name_orig": "Status LED On When Running Normal",
        "desc": "True: Status LED will light up green when running normal. False: Status LED will not be turned on when running normal.",
        "type": "bool",
        "min": "0",
        "max": "0",
        "res": "",
        "default": "False",
        "unit": "-",
        "options": ""
    },
    "status_led_on_when_not_running_normal": {
        "id": "status_led_on_when_not_running_normal",
        "param_no": 10273,
        "parent": 28000,
        "name": "Status LED On When Not Running Normal",
        "name_orig": "Status LED On When Not Running Normal",
        "desc": "True: Status LED will show flashing signals, described in the manual, when an alarm or warning is present. False: Status LED will not be turned on when an alarm or warning is present.",
        "type": "bool",
        "min": "0",
        "max": "0",
        "res": "",
        "default": "False",
        "unit": "-",
        "options": ""
    },
    "wifi_ap_enabled_after_power_on": {
        "id": "wifi_ap_enabled_after_power_on",
        "param_no": 10292,
        "parent": 30000,
        "name": "Wi-Fi AP enabled After Power On",
        "name_orig": "Wi-Fi AP enabled After Power On",
        "desc": "True: The Wi-Fi Access Point is enabled at power on after the initial boot is done. False: The Wi-Fi Access Point is not automatically enabled at power on.",
        "type": "bool",
        "min": "0",
        "max": "0",
        "res": "",
        "default": "True",
        "unit": "-",
        "options": ""
    },
    "wifi_ap_auto_off_timer": {
        "id": "wifi_ap_auto_off_timer",
        "param_no": 10293,
        "parent": 30000,
        "name": "Wi-Fi AP Auto Off Timer",
        "name_orig": "Wi-Fi AP Auto Off Timer",
        "desc": "Time (in hours) the Wi-Fi Access Point will stay active after being enabled. If set to 0, the Access Point will stay active indefinitely when enabled.",
        "type": "int",
        "min": "0",
        "max": "24",
        "res": "",
        "default": "6",
        "unit": "hour",
        "options": ""
    },
    "modbus_tcp_ip_enabled": {
        "id": "modbus_tcp_ip_enabled",
        "param_no": 10330,
        "parent": 31000,
        "name": "Modbus TCP/IP enabled",
        "name_orig": "Modbus TCP/IP enabled",
        "desc": "True: The unit can be controlled and monitored through Modbus TCP/IP (Ethernet). Only enable if on a isolated/secure network. False: The unit cannot be controlled or monitored through Modbus TCP/IP (Ethernet).",
        "type": "bool",
        "min": "0",
        "max": "0",
        "res": "",
        "default": "False",
        "unit": "-",
        "options": ""
    },
    "modbus_tcp_ip_option_installed": {
        "id": "modbus_tcp_ip_option_installed",
        "param_no": 10331,
        "parent": 31000,
        "name": "Modbus TCP/IP option installed",
        "name_orig": "Modbus TCP/IP option installed",
        "desc": "True: Modbus TCP/IP (Ethernet) option is installed, which allows the unit to enable Modbus TCP/IP through. False: Modbus TCP/IP (Ethernet) option is not installed, and enablement of Modbus TCP/IP can not be done.",
        "type": "bool",
        "min": "0",
        "max": "0",
        "res": "",
        "default": "False",
        "unit": "-",
        "options": ""
    },
    "modem_4g_installed": {
        "id": "modem_4g_installed",
        "param_no": 10339,
        "parent": 32000,
        "name": "4G modem installed",
        "name_orig": "4G modem installed",
        "desc": "True: The 4G modem option is installed. The modem is powered, managed by NetworkManager/ModemManager, and provides cellular data when a SIM card is inserted. False: No 4G modem is installed; the modem stack stays powered off and ModemManager is disabled. Takes effect after a reboot.",
        "type": "bool",
        "min": "0",
        "max": "0",
        "res": "",
        "default": "False",
        "unit": "-",
        "options": ""
    },
    "am_unit_type": {
        "id": "am_unit_type",
        "param_no": 10050,
        "parent": 34000,
        "name": "AM Unit Type",
        "name_orig": "AM Unit Type",
        "desc": "Type of ventilation unit.",
        "type": "enum",
        "min": "0",
        "max": "3",
        "res": "",
        "default": "2",
        "unit": "-",
        "options": {
            "0": "AMX4 Prototype",
            "1": "AMX4 Field Test",
            "2": "AMX4",
            "3": "AM Unit Max"
        }
    },
    "ccm_installed": {
        "id": "ccm_installed",
        "param_no": 10204,
        "parent": 34000,
        "name": "CCM Installed",
        "name_orig": "CCM Installed",
        "desc": "True: Costumer Connection Module is installed. False: Costumer Connection Module is not installed.",
        "type": "bool",
        "min": "0",
        "max": "0",
        "res": "",
        "default": "False",
        "unit": "-",
        "options": ""
    },
    "co2_sensor_installed_ai": {
        "id": "co2_sensor_installed_ai",
        "param_no": 10068,
        "parent": 35000,
        "name": "CO2 Sensor Installed AI",
        "name_orig": "CO2 Sensor Installed AI",
        "desc": "CO2 sensor installed: Air Inlet",
        "type": "enum",
        "min": "0",
        "max": "2",
        "res": "",
        "default": "0",
        "unit": "-",
        "options": {
            "0": "Off",
            "1": "Digital",
            "2": "Analog 0-10V"
        }
    },
    "co2_sensor_installed_ar": {
        "id": "co2_sensor_installed_ar",
        "param_no": 10069,
        "parent": 35000,
        "name": "CO2 Sensor Installed AR",
        "name_orig": "CO2 Sensor Installed AR",
        "desc": "CO2 sensor installed: Air Room",
        "type": "enum",
        "min": "0",
        "max": "2",
        "res": "",
        "default": "0",
        "unit": "-",
        "options": {
            "0": "Off",
            "1": "Digital",
            "2": "Analog 0-10V"
        }
    },
    "co2_sensor_installed_ae": {
        "id": "co2_sensor_installed_ae",
        "param_no": 10070,
        "parent": 35000,
        "name": "CO2 Sensor Installed AE",
        "name_orig": "CO2 Sensor Installed AE",
        "desc": "CO2 sensor installed: Air Exhaust",
        "type": "enum",
        "min": "0",
        "max": "2",
        "res": "",
        "default": "0",
        "unit": "-",
        "options": {
            "0": "Off",
            "1": "Digital",
            "2": "Analog 0-10V"
        }
    },
    "co2_sensor_installed_ao": {
        "id": "co2_sensor_installed_ao",
        "param_no": 10071,
        "parent": 35000,
        "name": "CO2 Sensor Installed AO",
        "name_orig": "CO2 Sensor Installed AO",
        "desc": "CO2 sensor installed: Air Outside",
        "type": "enum",
        "min": "0",
        "max": "2",
        "res": "",
        "default": "0",
        "unit": "-",
        "options": {
            "0": "Off",
            "1": "Digital",
            "2": "Analog 0-10V"
        }
    },
    "analog_co2_sensor_ppm_range_min": {
        "id": "analog_co2_sensor_ppm_range_min",
        "param_no": 10072,
        "parent": 35000,
        "name": "Analog CO2 Sensor ppm Range Min",
        "name_orig": "Analog CO2 Sensor ppm Range Min",
        "desc": "Minimum CO2 concentration for the CO2 sensor",
        "type": "int",
        "min": "0",
        "max": "65000",
        "res": "",
        "default": "0",
        "unit": "ppm",
        "options": ""
    },
    "analog_co2_sensor_ppm_range_max": {
        "id": "analog_co2_sensor_ppm_range_max",
        "param_no": 10073,
        "parent": 35000,
        "name": "Analog CO2 Sensor ppm Range Max",
        "name_orig": "Analog CO2 Sensor ppm Range Max",
        "desc": "Maximum CO2 concentration for the CO2 sensor",
        "type": "int",
        "min": "0",
        "max": "65000",
        "res": "",
        "default": "2000",
        "unit": "ppm",
        "options": ""
    },
    "analog_co2_sensor_volt_range_min": {
        "id": "analog_co2_sensor_volt_range_min",
        "param_no": 10074,
        "parent": 35000,
        "name": "Analog CO2 Sensor Volt Range Min",
        "name_orig": "Analog CO2 Sensor Volt Range Min",
        "desc": "Minimum Volt for the CO2 sensor",
        "type": "decimal",
        "min": "0.0",
        "max": "10.0",
        "res": "",
        "default": "0.0",
        "unit": "V",
        "options": ""
    },
    "analog_co2_sensor_volt_range_max": {
        "id": "analog_co2_sensor_volt_range_max",
        "param_no": 10075,
        "parent": 35000,
        "name": "Analog CO2 Sensor Volt Range Max",
        "name_orig": "Analog CO2 Sensor Volt Range Max",
        "desc": "Maximum Volt for the CO2 sensor",
        "type": "decimal",
        "min": "0.0",
        "max": "10.0",
        "res": "",
        "default": "10.0",
        "unit": "V",
        "options": ""
    },
    "aa_mode": {
        "id": "aa_mode",
        "param_no": 10076,
        "parent": 37000,
        "name": "AA Mode",
        "name_orig": "AA Mode",
        "desc": "Adaptive Airflow Installed",
        "type": "enum",
        "min": "0",
        "max": "3",
        "res": "",
        "default": "0",
        "unit": "-",
        "options": {
            "0": "Off",
            "1": "Time Controlled",
            "2": "Voltage Controlled",
            "3": "Self Return"
        }
    },
    "aa_run_time": {
        "id": "aa_run_time",
        "param_no": 10077,
        "parent": 37000,
        "name": "AA Run Time",
        "name_orig": "AA Run Time",
        "desc": "RunTime, is the time it takes the actuator to move from end2end",
        "type": "int",
        "min": "0",
        "max": "999",
        "res": "",
        "default": "0",
        "unit": "sec",
        "options": ""
    },
    "aa_upward_direction": {
        "id": "aa_upward_direction",
        "param_no": 10078,
        "parent": 37000,
        "name": "AA Upward Direction",
        "name_orig": "AA Upward Direction",
        "desc": "Rotation direction to point the Adaptive Airflow Damper Upward",
        "type": "enum",
        "min": "0",
        "max": "1",
        "res": "",
        "default": "0",
        "unit": "-",
        "options": {
            "0": "CW",
            "1": "CCW"
        }
    },
    "aa_cw_rotation": {
        "id": "aa_cw_rotation",
        "param_no": 10079,
        "parent": 37000,
        "name": "AA CW Rotation",
        "name_orig": "AA CW Rotation",
        "desc": "Settings to rotate Clock Wise (CW)",
        "type": "enum",
        "min": "0",
        "max": "2",
        "res": "",
        "default": "1",
        "unit": "-",
        "options": {
            "0": "L2",
            "1": "L3",
            "2": "L2+L3"
        }
    },
    "aa_ccw_rotation": {
        "id": "aa_ccw_rotation",
        "param_no": 10080,
        "parent": 37000,
        "name": "AA CCW Rotation",
        "name_orig": "AA CCW Rotation",
        "desc": "Settings to rotate Counter Clock Wise (CCW)",
        "type": "enum",
        "min": "0",
        "max": "2",
        "res": "",
        "default": "0",
        "unit": "-",
        "options": {
            "0": "L2",
            "1": "L3",
            "2": "L2+L3"
        }
    },
    "bp_mode": {
        "id": "bp_mode",
        "param_no": 10082,
        "parent": 38000,
        "name": "BP Mode",
        "name_orig": "BP Mode",
        "desc": "Bypass installed",
        "type": "enum",
        "min": "0",
        "max": "3",
        "res": "",
        "default": "0",
        "unit": "-",
        "options": {
            "0": "Off",
            "1": "Time Controlled",
            "2": "Voltage Controlled",
            "3": "Self Return"
        }
    },
    "bp_run_time": {
        "id": "bp_run_time",
        "param_no": 10083,
        "parent": 38000,
        "name": "BP Run Time",
        "name_orig": "BP Run Time",
        "desc": "RunTime, is the time it takes the actuator to move from end2end (both Voltage and Time Controlled)",
        "type": "int",
        "min": "0",
        "max": "999",
        "res": "",
        "default": "0",
        "unit": "sec",
        "options": ""
    },
    "bp_open_direction": {
        "id": "bp_open_direction",
        "param_no": 10084,
        "parent": 38000,
        "name": "BP Open Direction",
        "name_orig": "BP Open Direction",
        "desc": "Open Damper, the direction the actuator rotates, to open the damper",
        "type": "enum",
        "min": "0",
        "max": "1",
        "res": "",
        "default": "1",
        "unit": "-",
        "options": {
            "0": "CW",
            "1": "CCW"
        }
    },
    "bp_cw_rotation": {
        "id": "bp_cw_rotation",
        "param_no": 10085,
        "parent": 38000,
        "name": "BP CW Rotation",
        "name_orig": "BP CW Rotation",
        "desc": "Settings to rotate Clock Wise (CW)",
        "type": "enum",
        "min": "0",
        "max": "2",
        "res": "",
        "default": "1",
        "unit": "-",
        "options": {
            "0": "L2",
            "1": "L3",
            "2": "L2+L3"
        }
    },
    "bp_ccw_rotation": {
        "id": "bp_ccw_rotation",
        "param_no": 10086,
        "parent": 38000,
        "name": "BP CCW Rotation",
        "name_orig": "BP CCW Rotation",
        "desc": "Settings to rotate Counter Clock Wise (CCW)",
        "type": "enum",
        "min": "0",
        "max": "2",
        "res": "",
        "default": "0",
        "unit": "-",
        "options": {
            "0": "L2",
            "1": "L3",
            "2": "L2+L3"
        }
    },
    "mds_mode": {
        "id": "mds_mode",
        "param_no": 10091,
        "parent": 39000,
        "name": "MDS Mode",
        "name_orig": "MDS Mode",
        "desc": "Main Damper installed",
        "type": "enum",
        "min": "0",
        "max": "3",
        "res": "",
        "default": "0",
        "unit": "-",
        "options": {
            "0": "Off",
            "1": "Time Controlled",
            "2": "Voltage Controlled",
            "3": "Self Return"
        }
    },
    "mds_run_time": {
        "id": "mds_run_time",
        "param_no": 10092,
        "parent": 39000,
        "name": "MDS Run Time",
        "name_orig": "MDS Run Time",
        "desc": "The time it takes for the MD damper to operate from 0-100%",
        "type": "int",
        "min": "0",
        "max": "999",
        "res": "",
        "default": "0",
        "unit": "s",
        "options": ""
    },
    "mds_open_direction": {
        "id": "mds_open_direction",
        "param_no": 10093,
        "parent": 39000,
        "name": "MDS Open Direction",
        "name_orig": "MDS Open Direction",
        "desc": "Open Main Damper, the direction the actuator rotates, to open the damper",
        "type": "enum",
        "min": "0",
        "max": "1",
        "res": "",
        "default": "0",
        "unit": "-",
        "options": {
            "0": "CW",
            "1": "CCW"
        }
    },
    "mds_cw_rotation": {
        "id": "mds_cw_rotation",
        "param_no": 10094,
        "parent": 39000,
        "name": "MDS CW Rotation",
        "name_orig": "MDS CW Rotation",
        "desc": "Settings to rotate Clock Wise (CW)",
        "type": "enum",
        "min": "0",
        "max": "2",
        "res": "",
        "default": "1",
        "unit": "-",
        "options": {
            "0": "L2",
            "1": "L3",
            "2": "L2+L3"
        }
    },
    "mds_ccw_rotation": {
        "id": "mds_ccw_rotation",
        "param_no": 10095,
        "parent": 39000,
        "name": "MDS CCW Rotation",
        "name_orig": "MDS CCW Rotation",
        "desc": "Settings to rotate Counter Clock Wise (CCW)",
        "type": "enum",
        "min": "0",
        "max": "2",
        "res": "",
        "default": "0",
        "unit": "-",
        "options": {
            "0": "L2",
            "1": "L3",
            "2": "L2+L3"
        }
    },
    "mde_mode": {
        "id": "mde_mode",
        "param_no": 10096,
        "parent": 39000,
        "name": "MDE Mode",
        "name_orig": "MDE Mode",
        "desc": "ON handles both \"TimeControlled\" and \"Self Return\"",
        "type": "enum",
        "min": "0",
        "max": "3",
        "res": "",
        "default": "0",
        "unit": "-",
        "options": {
            "0": "Off",
            "1": "Time Controlled",
            "2": "Voltage Controlled",
            "3": "Self Return"
        }
    },
    "mde_run_time": {
        "id": "mde_run_time",
        "param_no": 10097,
        "parent": 39000,
        "name": "MDE Run Time",
        "name_orig": "MDE Run Time",
        "desc": "The time it takes for the MD damper to operate from 0-100%",
        "type": "int",
        "min": "0",
        "max": "999",
        "res": "",
        "default": "0",
        "unit": "s",
        "options": ""
    },
    "mde_open_direction": {
        "id": "mde_open_direction",
        "param_no": 10098,
        "parent": 39000,
        "name": "MDE Open Direction",
        "name_orig": "MDE Open Direction",
        "desc": "Open Main Damper, the direction the actuator rotates, to open the damper",
        "type": "enum",
        "min": "0",
        "max": "1",
        "res": "",
        "default": "0",
        "unit": "-",
        "options": {
            "0": "CW",
            "1": "CCW"
        }
    },
    "mde_cw_rotation": {
        "id": "mde_cw_rotation",
        "param_no": 10099,
        "parent": 39000,
        "name": "MDE CW Rotation",
        "name_orig": "MDE CW Rotation",
        "desc": "Settings to rotate Clock Wise (CW)",
        "type": "enum",
        "min": "0",
        "max": "2",
        "res": "",
        "default": "1",
        "unit": "-",
        "options": {
            "0": "L2",
            "1": "L3",
            "2": "L2+L3"
        }
    },
    "mde_ccw_rotation": {
        "id": "mde_ccw_rotation",
        "param_no": 10100,
        "parent": 39000,
        "name": "MDE CCW Rotation",
        "name_orig": "MDE CCW Rotation",
        "desc": "Settings to rotate Counter Clock Wise (CCW)",
        "type": "enum",
        "min": "0",
        "max": "2",
        "res": "",
        "default": "0",
        "unit": "-",
        "options": {
            "0": "L2",
            "1": "L3",
            "2": "L2+L3"
        }
    },
    "md_min_opening": {
        "id": "md_min_opening",
        "param_no": 10101,
        "parent": 39000,
        "name": "MD Min Opening",
        "name_orig": "MD Min Opening",
        "desc": "The minimum MD open% before setting \"status = running\"",
        "type": "decimal",
        "min": "0.0",
        "max": "100.0",
        "res": "",
        "default": "50.0",
        "unit": "%",
        "options": ""
    },
    "rci_mode": {
        "id": "rci_mode",
        "param_no": 10102,
        "parent": 40000,
        "name": "RCI Mode",
        "name_orig": "RCI Mode",
        "desc": "",
        "type": "enum",
        "min": "0",
        "max": "3",
        "res": "",
        "default": "0",
        "unit": "-",
        "options": {
            "0": "Off",
            "1": "Time Controlled",
            "2": "Voltage Controlled",
            "3": "Self Return"
        }
    },
    "rci_run_time": {
        "id": "rci_run_time",
        "param_no": 10103,
        "parent": 40000,
        "name": "RCI Run Time",
        "name_orig": "RCI Run Time",
        "desc": "RunTime, is the time it takes the actuator to move from end2end (both Voltage and Time Controlled)",
        "type": "int",
        "min": "0",
        "max": "999",
        "res": "",
        "default": "0",
        "unit": "sec",
        "options": ""
    },
    "rci_open_direction": {
        "id": "rci_open_direction",
        "param_no": 10104,
        "parent": 40000,
        "name": "RCI Open Direction",
        "name_orig": "RCI Open Direction",
        "desc": "Open Damper, the direction the actuator rotates, to open the damper",
        "type": "enum",
        "min": "0",
        "max": "1",
        "res": "",
        "default": "1",
        "unit": "-",
        "options": {
            "0": "CW",
            "1": "CCW"
        }
    },
    "rci_cw_rotation": {
        "id": "rci_cw_rotation",
        "param_no": 10105,
        "parent": 40000,
        "name": "RCI CW Rotation",
        "name_orig": "RCI CW Rotation",
        "desc": "Settings to rotate Clock Wise (CW)",
        "type": "enum",
        "min": "0",
        "max": "2",
        "res": "",
        "default": "1",
        "unit": "-",
        "options": {
            "0": "L2",
            "1": "L3",
            "2": "L2+L3"
        }
    },
    "rci_ccw_rotation": {
        "id": "rci_ccw_rotation",
        "param_no": 10106,
        "parent": 40000,
        "name": "RCI CCW Rotation",
        "name_orig": "RCI CCW Rotation",
        "desc": "Settings to rotate Counter Clock Wise (CCW)",
        "type": "enum",
        "min": "0",
        "max": "2",
        "res": "",
        "default": "0",
        "unit": "-",
        "options": {
            "0": "L2",
            "1": "L3",
            "2": "L2+L3"
        }
    },
    "rco_mode": {
        "id": "rco_mode",
        "param_no": 10107,
        "parent": 40000,
        "name": "RCO Mode",
        "name_orig": "RCO Mode",
        "desc": "",
        "type": "enum",
        "min": "0",
        "max": "3",
        "res": "",
        "default": "0",
        "unit": "-",
        "options": {
            "0": "Off",
            "1": "Time Controlled",
            "2": "Voltage Controlled",
            "3": "Self Return"
        }
    },
    "rco_run_time": {
        "id": "rco_run_time",
        "param_no": 10108,
        "parent": 40000,
        "name": "RCO Run Time",
        "name_orig": "RCO Run Time",
        "desc": "RunTime, is the time it takes the actuator to move from end2end (both Voltage and Time Controlled)",
        "type": "int",
        "min": "0",
        "max": "999",
        "res": "",
        "default": "0",
        "unit": "sec",
        "options": ""
    },
    "rco_open_direction": {
        "id": "rco_open_direction",
        "param_no": 10109,
        "parent": 40000,
        "name": "RCO Open Direction",
        "name_orig": "RCO Open Direction",
        "desc": "Open Damper, the direction the actuator rotates, to open the damper",
        "type": "enum",
        "min": "0",
        "max": "1",
        "res": "",
        "default": "0",
        "unit": "-",
        "options": {
            "0": "CW",
            "1": "CCW"
        }
    },
    "rco_cw_rotation": {
        "id": "rco_cw_rotation",
        "param_no": 10110,
        "parent": 40000,
        "name": "RCO CW Rotation",
        "name_orig": "RCO CW Rotation",
        "desc": "Settings to rotate Clock Wise (CW)",
        "type": "enum",
        "min": "0",
        "max": "2",
        "res": "",
        "default": "1",
        "unit": "-",
        "options": {
            "0": "L2",
            "1": "L3",
            "2": "L2+L3"
        }
    },
    "rco_ccw_rotation": {
        "id": "rco_ccw_rotation",
        "param_no": 10111,
        "parent": 40000,
        "name": "RCO CCW Rotation",
        "name_orig": "RCO CCW Rotation",
        "desc": "Settings to rotate Counter Clock Wise (CCW)",
        "type": "enum",
        "min": "0",
        "max": "2",
        "res": "",
        "default": "0",
        "unit": "-",
        "options": {
            "0": "L2",
            "1": "L3",
            "2": "L2+L3"
        }
    },
    "fan_supply_min_pct": {
        "id": "fan_supply_min_pct",
        "param_no": 10114,
        "parent": 41000,
        "name": "Fan Supply Min pct",
        "name_orig": "Fan Supply Min pct",
        "desc": "",
        "type": "decimal",
        "min": "0.0",
        "max": "100.0",
        "res": "",
        "default": "0.0",
        "unit": "%",
        "options": ""
    },
    "fan_supply_vent_max_pct": {
        "id": "fan_supply_vent_max_pct",
        "param_no": 10197,
        "parent": 41000,
        "name": "Fan Supply Vent Max pct",
        "name_orig": "Fan Supply Vent Max pct",
        "desc": "",
        "type": "decimal",
        "min": "0.0",
        "max": "100.0",
        "res": "",
        "default": "10.0",
        "unit": "%",
        "options": ""
    },
    "fan_supply_recirc_max_pct": {
        "id": "fan_supply_recirc_max_pct",
        "param_no": 10198,
        "parent": 41000,
        "name": "Fan Supply Recirc Max pct",
        "name_orig": "Fan Supply Recirc Max pct",
        "desc": "",
        "type": "decimal",
        "min": "0.0",
        "max": "100.0",
        "res": "",
        "default": "10.0",
        "unit": "%",
        "options": ""
    },
    "fan_extraction_min_pct": {
        "id": "fan_extraction_min_pct",
        "param_no": 10118,
        "parent": 41000,
        "name": "Fan Extraction Min pct",
        "name_orig": "Fan Extraction Min pct",
        "desc": "",
        "type": "decimal",
        "min": "0.0",
        "max": "100.0",
        "res": "",
        "default": "0.0",
        "unit": "%",
        "options": ""
    },
    "fan_extraction_vent_max_pct": {
        "id": "fan_extraction_vent_max_pct",
        "param_no": 10199,
        "parent": 41000,
        "name": "Fan Extraction Vent Max pct",
        "name_orig": "Fan Extraction Vent Max pct",
        "desc": "",
        "type": "decimal",
        "min": "0.0",
        "max": "100.0",
        "res": "",
        "default": "10.0",
        "unit": "%",
        "options": ""
    },
    "fan_extraction_recirc_max_pct": {
        "id": "fan_extraction_recirc_max_pct",
        "param_no": 10200,
        "parent": 41000,
        "name": "Fan Extraction Recirc Max pct",
        "name_orig": "Fan Extraction Recirc Max pct",
        "desc": "",
        "type": "decimal",
        "min": "0.0",
        "max": "100.0",
        "res": "",
        "default": "10.0",
        "unit": "%",
        "options": ""
    },
    "pre_heater_installed": {
        "id": "pre_heater_installed",
        "param_no": 10121,
        "parent": 42000,
        "name": "Pre Heater Installed",
        "name_orig": "Pre Heater Installed",
        "desc": "True: If Preheater is installed.  False: If Preheater is not installed.",
        "type": "enum",
        "min": "0",
        "max": "2",
        "res": "",
        "default": "0",
        "unit": "-",
        "options": {
            "0": "Off",
            "1": "Electric",
            "2": "Water"
        }
    },
    "rh_sensor_installed_ai": {
        "id": "rh_sensor_installed_ai",
        "param_no": 10123,
        "parent": 43000,
        "name": "RH Sensor Installed AI",
        "name_orig": "RH Sensor Installed AI",
        "desc": "True: If  Sensor is installed.  False: If  Sensor is not installed.",
        "type": "enum",
        "min": "0",
        "max": "2",
        "res": "",
        "default": "0",
        "unit": "-",
        "options": {
            "0": "Off",
            "1": "Digital",
            "2": "Analog 0-10V"
        }
    },
    "rh_sensor_installed_ar": {
        "id": "rh_sensor_installed_ar",
        "param_no": 10124,
        "parent": 43000,
        "name": "RH Sensor Installed AR",
        "name_orig": "RH Sensor Installed AR",
        "desc": "True: If  Sensor is installed.  False: If  Sensor is not installed.",
        "type": "enum",
        "min": "0",
        "max": "2",
        "res": "",
        "default": "0",
        "unit": "-",
        "options": {
            "0": "Off",
            "1": "Digital",
            "2": "Analog 0-10V"
        }
    },
    "rh_sensor_installed_ae": {
        "id": "rh_sensor_installed_ae",
        "param_no": 10125,
        "parent": 43000,
        "name": "RH Sensor Installed AE",
        "name_orig": "RH Sensor Installed AE",
        "desc": "True: If  Sensor is installed.  False: If  Sensor is not installed.",
        "type": "enum",
        "min": "0",
        "max": "2",
        "res": "",
        "default": "0",
        "unit": "-",
        "options": {
            "0": "Off",
            "1": "Digital",
            "2": "Analog 0-10V"
        }
    },
    "rh_sensor_installed_ao": {
        "id": "rh_sensor_installed_ao",
        "param_no": 10126,
        "parent": 43000,
        "name": "RH Sensor Installed AO",
        "name_orig": "RH Sensor Installed AO",
        "desc": "True: If  Sensor is installed.  False: If  Sensor is not installed.",
        "type": "enum",
        "min": "0",
        "max": "2",
        "res": "",
        "default": "0",
        "unit": "-",
        "options": {
            "0": "Off",
            "1": "Digital",
            "2": "Analog 0-10V"
        }
    },
    "analog_rh_sensor_pct_range_min": {
        "id": "analog_rh_sensor_pct_range_min",
        "param_no": 10127,
        "parent": 43000,
        "name": "Analog RH Sensor pct Range Min",
        "name_orig": "Analog RH Sensor pct Range Min",
        "desc": "Minimum RH concentration for the RH sensor",
        "type": "decimal",
        "min": "0.0",
        "max": "100.0",
        "res": "",
        "default": "0.0",
        "unit": "%",
        "options": ""
    },
    "analog_rh_sensor_pct_range_max": {
        "id": "analog_rh_sensor_pct_range_max",
        "param_no": 10128,
        "parent": 43000,
        "name": "Analog RH Sensor pct Range Max",
        "name_orig": "Analog RH Sensor pct Range Max",
        "desc": "Maximum RH concentration for the RH sensor",
        "type": "decimal",
        "min": "0.0",
        "max": "100.0",
        "res": "",
        "default": "100.0",
        "unit": "%",
        "options": ""
    },
    "analog_rh_sensor_volt_range_min": {
        "id": "analog_rh_sensor_volt_range_min",
        "param_no": 10129,
        "parent": 43000,
        "name": "Analog RH Sensor Volt Range Min",
        "name_orig": "Analog RH Sensor Volt Range Min",
        "desc": "Mimum Volt for the RH sensor",
        "type": "decimal",
        "min": "0.0",
        "max": "10.0",
        "res": "",
        "default": "0.0",
        "unit": "V",
        "options": ""
    },
    "analog_rh_sensor_volt_range_max": {
        "id": "analog_rh_sensor_volt_range_max",
        "param_no": 10130,
        "parent": 43000,
        "name": "Analog RH Sensor Volt Range Max",
        "name_orig": "Analog RH Sensor Volt Range Max",
        "desc": "Maximum Volt for the RH sensor",
        "type": "decimal",
        "min": "0.0",
        "max": "10.0",
        "res": "",
        "default": "10.0",
        "unit": "V",
        "options": ""
    },
    "hvac_mode": {
        "id": "hvac_mode",
        "param_no": 10131,
        "parent": 44000,
        "name": "HVAC Mode",
        "name_orig": "HVAC Mode",
        "desc": "HP Installed",
        "type": "enum",
        "min": "0",
        "max": "3",
        "res": "",
        "default": "0",
        "unit": "-",
        "options": {
            "0": "Ventilation Only",
            "1": "Cooling",
            "2": "Heating",
            "3": "Cooling and Heating"
        }
    },
    "hvac_eev_installed": {
        "id": "hvac_eev_installed",
        "param_no": 10132,
        "parent": 44000,
        "name": "HVAC EEV Installed",
        "name_orig": "HVAC EEV Installed",
        "desc": "",
        "type": "bool",
        "min": "0",
        "max": "0",
        "res": "",
        "default": "False",
        "unit": "-",
        "options": ""
    },
    "hvac_eev_steps": {
        "id": "hvac_eev_steps",
        "param_no": 10133,
        "parent": 44000,
        "name": "HVAC EEV Steps",
        "name_orig": "HVAC EEV Steps",
        "desc": "Number of steps for the stepper drive to move the valve from end-to-end.",
        "type": "int",
        "min": "0",
        "max": "520",
        "res": "",
        "default": "0",
        "unit": "-",
        "options": ""
    },
    "hvac_eev_calibration_steps": {
        "id": "hvac_eev_calibration_steps",
        "param_no": 10134,
        "parent": 44000,
        "name": "HVAC EEV Calibration Steps",
        "name_orig": "HVAC EEV Calibration Steps",
        "desc": "Number of steps for the stepper drive to ensure calibration towards closed position. Typically around end-to-end + [10-50] steps.",
        "type": "int",
        "min": "0",
        "max": "520",
        "res": "",
        "default": "0",
        "unit": "-",
        "options": ""
    },
    "hvac_eev_calibration_time": {
        "id": "hvac_eev_calibration_time",
        "param_no": 10135,
        "parent": 44000,
        "name": "HVAC EEV Calibration Time",
        "name_orig": "HVAC EEV Calibration Time",
        "desc": "The time it takes to calibrate, OBS: must be equal to or larger than the time it takes!",
        "type": "int",
        "min": "0",
        "max": "255",
        "res": "",
        "default": "0",
        "unit": "s",
        "options": ""
    },
    "hvac_four_way_valve_active": {
        "id": "hvac_four_way_valve_active",
        "param_no": 10136,
        "parent": 44000,
        "name": "HVAC Four Way Valve Active",
        "name_orig": "HVAC Four Way Valve Active",
        "desc": "Activate to perform the selected task",
        "type": "enum",
        "min": "0",
        "max": "1",
        "res": "",
        "default": "0",
        "unit": "-",
        "options": {
            "0": "Cooling",
            "1": "Heating"
        }
    },
    "hvac_fc_power_mode": {
        "id": "hvac_fc_power_mode",
        "param_no": 10137,
        "parent": 44000,
        "name": "HVAC FC Power Mode",
        "name_orig": "HVAC FC Power Mode",
        "desc": "",
        "type": "enum",
        "min": "0",
        "max": "1",
        "res": "",
        "default": "1",
        "unit": "-",
        "options": {
            "0": "Power Off",
            "1": "Go Idle"
        }
    },
    "pressure_switch_installed_vic": {
        "id": "pressure_switch_installed_vic",
        "param_no": 10138,
        "parent": 45000,
        "name": "Pressure Switch Installed VIC",
        "name_orig": "Pressure Switch Installed VIC",
        "desc": "Pressure Switch Vapor Into Compressor",
        "type": "enum",
        "min": "0",
        "max": "2",
        "res": "",
        "default": "0",
        "unit": "-",
        "options": {
            "0": "Off",
            "1": "Aware",
            "2": "Frequency Converter"
        }
    },
    "pressure_switch_installed_voc": {
        "id": "pressure_switch_installed_voc",
        "param_no": 10139,
        "parent": 45000,
        "name": "Pressure Switch Installed VOC",
        "name_orig": "Pressure Switch Installed VOC",
        "desc": "Pressure Switch Vapor Out of Compressor",
        "type": "enum",
        "min": "0",
        "max": "2",
        "res": "",
        "default": "0",
        "unit": "-",
        "options": {
            "0": "Off",
            "1": "Aware",
            "2": "Frequency Converter"
        }
    },
    "pressure_transmitter_installed_vti": {
        "id": "pressure_transmitter_installed_vti",
        "param_no": 10140,
        "parent": 45000,
        "name": "Pressure Transmitter Installed VTI",
        "name_orig": "Pressure Transmitter Installed VTI",
        "desc": "Pressure Tranmitter Vapor Top Inside heat exchanger",
        "type": "enum",
        "min": "0",
        "max": "4",
        "res": "",
        "default": "0",
        "unit": "-",
        "options": {
            "0": "Off",
            "1": "Digital",
            "2": "Analog 0-10V",
            "3": "Analog 0.5V-3.5V",
            "4": "Analog 0-20 mA"
        }
    },
    "pressure_transmitter_installed_lbi": {
        "id": "pressure_transmitter_installed_lbi",
        "param_no": 10141,
        "parent": 45000,
        "name": "Pressure Transmitter Installed LBI",
        "name_orig": "Pressure Transmitter Installed LBI",
        "desc": "Pressure Tranmitter Liquid Bottom Inside heat exchanger",
        "type": "enum",
        "min": "0",
        "max": "4",
        "res": "",
        "default": "0",
        "unit": "-",
        "options": {
            "0": "Off",
            "1": "Digital",
            "2": "Analog 0-10V",
            "3": "Analog 0.5V-3.5V",
            "4": "Analog 0-20 mA"
        }
    },
    "pressure_transmitter_installed_vto": {
        "id": "pressure_transmitter_installed_vto",
        "param_no": 10142,
        "parent": 45000,
        "name": "Pressure Transmitter Installed VTO",
        "name_orig": "Pressure Transmitter Installed VTO",
        "desc": "Pressure Tranmitter Vapor Top Outside heat exchanger",
        "type": "enum",
        "min": "0",
        "max": "4",
        "res": "",
        "default": "0",
        "unit": "-",
        "options": {
            "0": "Off",
            "1": "Digital",
            "2": "Analog 0-10V",
            "3": "Analog 0.5V-3.5V",
            "4": "Analog 0-20 mA"
        }
    },
    "pressure_transmitter_installed_lbo": {
        "id": "pressure_transmitter_installed_lbo",
        "param_no": 10143,
        "parent": 45000,
        "name": "Pressure Transmitter Installed LBO",
        "name_orig": "Pressure Transmitter Installed LBO",
        "desc": "Pressure Tranmitter Liquid Bottom Outside heat exchanger",
        "type": "enum",
        "min": "0",
        "max": "4",
        "res": "",
        "default": "0",
        "unit": "-",
        "options": {
            "0": "Off",
            "1": "Digital",
            "2": "Analog 0-10V",
            "3": "Analog 0.5V-3.5V",
            "4": "Analog 0-20 mA"
        }
    },
    "pressure_transmitter_installed_vic": {
        "id": "pressure_transmitter_installed_vic",
        "param_no": 10144,
        "parent": 45000,
        "name": "Pressure Transmitter Installed VIC",
        "name_orig": "Pressure Transmitter Installed VIC",
        "desc": "Pressure Tranmitter Vapor Into Compressor",
        "type": "enum",
        "min": "0",
        "max": "4",
        "res": "",
        "default": "0",
        "unit": "-",
        "options": {
            "0": "Off",
            "1": "Digital",
            "2": "Analog 0-10V",
            "3": "Analog 0.5V-3.5V",
            "4": "Analog 0-20 mA"
        }
    },
    "analog_v_pressure_transmitter_bar_range_min": {
        "id": "analog_v_pressure_transmitter_bar_range_min",
        "param_no": 10145,
        "parent": 45000,
        "name": "Analog V Pressure Transmitter Bar Range Min",
        "name_orig": "Analog V Pressure Transmitter Bar Range Min",
        "desc": "Minimum Pressure for the Pressure Transmitter",
        "type": "int",
        "min": "-100000",
        "max": "4000000",
        "res": "",
        "default": "0",
        "unit": "Bar",
        "options": ""
    },
    "analog_v_pressure_transmitter_bar_range_max": {
        "id": "analog_v_pressure_transmitter_bar_range_max",
        "param_no": 10146,
        "parent": 45000,
        "name": "Analog V Pressure Transmitter Bar Range Max",
        "name_orig": "Analog V Pressure Transmitter Bar Range Max",
        "desc": "Maximum Pressure for the Pressure Transmitter",
        "type": "int",
        "min": "-100000",
        "max": "4000000",
        "res": "",
        "default": "0",
        "unit": "Bar",
        "options": ""
    },
    "analog_v_pressure_transmitter_volt_range_min": {
        "id": "analog_v_pressure_transmitter_volt_range_min",
        "param_no": 10147,
        "parent": 45000,
        "name": "Analog V Pressure Transmitter Volt Range Min",
        "name_orig": "Analog V Pressure Transmitter Volt Range Min",
        "desc": "Mimum Volt for the RH sensor",
        "type": "decimal",
        "min": "0.0",
        "max": "10.0",
        "res": "",
        "default": "0.0",
        "unit": "V",
        "options": ""
    },
    "analog_v_pressure_transmitter_volt_range_max": {
        "id": "analog_v_pressure_transmitter_volt_range_max",
        "param_no": 10148,
        "parent": 45000,
        "name": "Analog V Pressure Transmitter Volt Range Max",
        "name_orig": "Analog V Pressure Transmitter Volt Range Max",
        "desc": "Maximum Volt for the RH sensor",
        "type": "decimal",
        "min": "0.0",
        "max": "10.0",
        "res": "",
        "default": "10.0",
        "unit": "V",
        "options": ""
    },
    "analog_i_pressure_transmitter_bar_range_min": {
        "id": "analog_i_pressure_transmitter_bar_range_min",
        "param_no": 10149,
        "parent": 45000,
        "name": "Analog I Pressure Transmitter Bar Range Min",
        "name_orig": "Analog I Pressure Transmitter Bar Range Min",
        "desc": "Minimum Pressure for the Pressure Transmitter",
        "type": "int",
        "min": "-100000",
        "max": "4000000",
        "res": "",
        "default": "0",
        "unit": "Bar",
        "options": ""
    },
    "analog_i_pressure_transmitter_bar_range_max": {
        "id": "analog_i_pressure_transmitter_bar_range_max",
        "param_no": 10150,
        "parent": 45000,
        "name": "Analog I Pressure Transmitter Bar Range Max",
        "name_orig": "Analog I Pressure Transmitter Bar Range Max",
        "desc": "Maximum Pressure for the Pressure Transmitter",
        "type": "int",
        "min": "-100000",
        "max": "4000000",
        "res": "",
        "default": "0",
        "unit": "Bar",
        "options": ""
    },
    "analog_i_pressure_transmitter_ma_range_min": {
        "id": "analog_i_pressure_transmitter_ma_range_min",
        "param_no": 10151,
        "parent": 45000,
        "name": "Analog I Pressure Transmitter mA Range Min",
        "name_orig": "Analog I Pressure Transmitter mA Range Min",
        "desc": "Mimum Current for the RH sensor",
        "type": "decimal",
        "min": "0.0",
        "max": "20.0",
        "res": "",
        "default": "4.0",
        "unit": "mA",
        "options": ""
    },
    "analog_i_pressure_transmitter_ma_range_max": {
        "id": "analog_i_pressure_transmitter_ma_range_max",
        "param_no": 10152,
        "parent": 45000,
        "name": "Analog I Pressure Transmitter mA Range Max",
        "name_orig": "Analog I Pressure Transmitter mA Range Max",
        "desc": "Maximum Current for the RH sensor",
        "type": "decimal",
        "min": "0.0",
        "max": "20.0",
        "res": "",
        "default": "20.0",
        "unit": "mA",
        "options": ""
    },
    "t_sensor_installed_ai": {
        "id": "t_sensor_installed_ai",
        "param_no": 10153,
        "parent": 46000,
        "name": "T Sensor Installed AI",
        "name_orig": "T Sensor Installed AI",
        "desc": "Temperature Air Inlet",
        "type": "enum",
        "min": "0",
        "max": "3",
        "res": "",
        "default": "0",
        "unit": "-",
        "options": {
            "0": "Off",
            "1": "Digital",
            "2": "Analog NTC",
            "3": "Pressure"
        }
    },
    "t_sensor_installed_ar": {
        "id": "t_sensor_installed_ar",
        "param_no": 10154,
        "parent": 46000,
        "name": "T Sensor Installed AR",
        "name_orig": "T Sensor Installed AR",
        "desc": "Temperature Air Room",
        "type": "enum",
        "min": "0",
        "max": "3",
        "res": "",
        "default": "0",
        "unit": "-",
        "options": {
            "0": "Off",
            "1": "Digital",
            "2": "Analog NTC",
            "3": "Pressure"
        }
    },
    "t_sensor_installed_ae": {
        "id": "t_sensor_installed_ae",
        "param_no": 10155,
        "parent": 46000,
        "name": "T Sensor Installed AE",
        "name_orig": "T Sensor Installed AE",
        "desc": "Temperature Air Exhaust",
        "type": "enum",
        "min": "0",
        "max": "3",
        "res": "",
        "default": "0",
        "unit": "-",
        "options": {
            "0": "Off",
            "1": "Digital",
            "2": "Analog NTC",
            "3": "Pressure"
        }
    },
    "t_sensor_installed_ao": {
        "id": "t_sensor_installed_ao",
        "param_no": 10156,
        "parent": 46000,
        "name": "T Sensor Installed AO",
        "name_orig": "T Sensor Installed AO",
        "desc": "Temperature Air Outside",
        "type": "enum",
        "min": "0",
        "max": "3",
        "res": "",
        "default": "0",
        "unit": "-",
        "options": {
            "0": "Off",
            "1": "Digital",
            "2": "Analog NTC",
            "3": "Pressure"
        }
    },
    "t_sensor_installed_aop": {
        "id": "t_sensor_installed_aop",
        "param_no": 10157,
        "parent": 46000,
        "name": "T Sensor Installed AOP",
        "name_orig": "T Sensor Installed AOP",
        "desc": "Temperature Air Out of Passive heat exchanger",
        "type": "enum",
        "min": "0",
        "max": "3",
        "res": "",
        "default": "0",
        "unit": "-",
        "options": {
            "0": "Off",
            "1": "Digital",
            "2": "Analog NTC",
            "3": "Pressure"
        }
    },
    "t_sensor_installed_aio": {
        "id": "t_sensor_installed_aio",
        "param_no": 10158,
        "parent": 46000,
        "name": "T Sensor Installed AIO",
        "name_orig": "T Sensor Installed AIO",
        "desc": "Temperature Air Into Outside heat exchanger",
        "type": "enum",
        "min": "0",
        "max": "3",
        "res": "",
        "default": "0",
        "unit": "-",
        "options": {
            "0": "Off",
            "1": "Digital",
            "2": "Analog NTC",
            "3": "Pressure"
        }
    },
    "t_sensor_installed_aii": {
        "id": "t_sensor_installed_aii",
        "param_no": 10159,
        "parent": 46000,
        "name": "T Sensor Installed AII",
        "name_orig": "T Sensor Installed AII",
        "desc": "Temperature Air Into Inside heat exchanger",
        "type": "enum",
        "min": "0",
        "max": "3",
        "res": "",
        "default": "0",
        "unit": "-",
        "options": {
            "0": "Off",
            "1": "Digital",
            "2": "Analog NTC",
            "3": "Pressure"
        }
    },
    "t_sensor_installed_vto": {
        "id": "t_sensor_installed_vto",
        "param_no": 10160,
        "parent": 46000,
        "name": "T Sensor Installed VTO",
        "name_orig": "T Sensor Installed VTO",
        "desc": "Temperature Vapor Top Outside heat exchanger",
        "type": "enum",
        "min": "0",
        "max": "3",
        "res": "",
        "default": "0",
        "unit": "-",
        "options": {
            "0": "Off",
            "1": "Digital",
            "2": "Analog NTC",
            "3": "Pressure"
        }
    },
    "t_sensor_installed_vti": {
        "id": "t_sensor_installed_vti",
        "param_no": 10161,
        "parent": 46000,
        "name": "T Sensor Installed VTI",
        "name_orig": "T Sensor Installed VTI",
        "desc": "Temperature Vapor Top Inside heat exchanger",
        "type": "enum",
        "min": "0",
        "max": "3",
        "res": "",
        "default": "0",
        "unit": "-",
        "options": {
            "0": "Off",
            "1": "Digital",
            "2": "Analog NTC",
            "3": "Pressure"
        }
    },
    "t_sensor_installed_voc": {
        "id": "t_sensor_installed_voc",
        "param_no": 10162,
        "parent": 46000,
        "name": "T Sensor Installed VOC",
        "name_orig": "T Sensor Installed VOC",
        "desc": "Temperature Vapor Out of Compressor",
        "type": "enum",
        "min": "0",
        "max": "3",
        "res": "",
        "default": "0",
        "unit": "-",
        "options": {
            "0": "Off",
            "1": "Digital",
            "2": "Analog NTC",
            "3": "Pressure"
        }
    },
    "t_sensor_installed_lbo": {
        "id": "t_sensor_installed_lbo",
        "param_no": 10163,
        "parent": 46000,
        "name": "T Sensor Installed LBO",
        "name_orig": "T Sensor Installed LBO",
        "desc": "Temperature Liquid Bottom Outside heat exchanger",
        "type": "enum",
        "min": "0",
        "max": "3",
        "res": "",
        "default": "0",
        "unit": "-",
        "options": {
            "0": "Off",
            "1": "Digital",
            "2": "Analog NTC",
            "3": "Pressure"
        }
    },
    "t_sensor_installed_lbi": {
        "id": "t_sensor_installed_lbi",
        "param_no": 10164,
        "parent": 46000,
        "name": "T Sensor Installed LBI",
        "name_orig": "T Sensor Installed LBI",
        "desc": "Temperature Liquid Bottom Inside heat exchanger",
        "type": "enum",
        "min": "0",
        "max": "3",
        "res": "",
        "default": "0",
        "unit": "-",
        "options": {
            "0": "Off",
            "1": "Digital",
            "2": "Analog NTC",
            "3": "Pressure"
        }
    },
    "t_sensor_installed_lie": {
        "id": "t_sensor_installed_lie",
        "param_no": 10165,
        "parent": 46000,
        "name": "T Sensor Installed LIE",
        "name_orig": "T Sensor Installed LIE",
        "desc": "Temperature Liquid Into Expansion unit",
        "type": "enum",
        "min": "0",
        "max": "3",
        "res": "",
        "default": "0",
        "unit": "-",
        "options": {
            "0": "Off",
            "1": "Digital",
            "2": "Analog NTC",
            "3": "Pressure"
        }
    },
    "t_sensor_installed_loe": {
        "id": "t_sensor_installed_loe",
        "param_no": 10166,
        "parent": 46000,
        "name": "T Sensor Installed LOE",
        "name_orig": "T Sensor Installed LOE",
        "desc": "Temperature Liquid Out of Expansion unit",
        "type": "enum",
        "min": "0",
        "max": "3",
        "res": "",
        "default": "0",
        "unit": "-",
        "options": {
            "0": "Off",
            "1": "Digital",
            "2": "Analog NTC",
            "3": "Pressure"
        }
    },
    "t_sensor_installed_pci": {
        "id": "t_sensor_installed_pci",
        "param_no": 10167,
        "parent": 46000,
        "name": "T Sensor Installed PCI",
        "name_orig": "T Sensor Installed PCI",
        "desc": "Temperature Phase Change Inside heat exchanger",
        "type": "enum",
        "min": "0",
        "max": "3",
        "res": "",
        "default": "0",
        "unit": "-",
        "options": {
            "0": "Off",
            "1": "Digital",
            "2": "Analog NTC",
            "3": "Pressure"
        }
    },
    "t_sensor_installed_pco": {
        "id": "t_sensor_installed_pco",
        "param_no": 10168,
        "parent": 46000,
        "name": "T Sensor Installed PCO",
        "name_orig": "T Sensor Installed PCO",
        "desc": "Temperature Phase Change Outside heat exchanger",
        "type": "enum",
        "min": "0",
        "max": "3",
        "res": "",
        "default": "0",
        "unit": "-",
        "options": {
            "0": "Off",
            "1": "Digital",
            "2": "Analog NTC",
            "3": "Pressure"
        }
    },
    "t_sensor_installed_vic": {
        "id": "t_sensor_installed_vic",
        "param_no": 10169,
        "parent": 46000,
        "name": "T Sensor Installed VIC",
        "name_orig": "T Sensor Installed VIC",
        "desc": "Temperature Vapor Into Compressor",
        "type": "enum",
        "min": "0",
        "max": "3",
        "res": "",
        "default": "0",
        "unit": "-",
        "options": {
            "0": "Off",
            "1": "Digital",
            "2": "Analog NTC",
            "3": "Pressure"
        }
    },
    "tvoc_sensor_installed_ai": {
        "id": "tvoc_sensor_installed_ai",
        "param_no": 10170,
        "parent": 47000,
        "name": "TVOC Sensor Installed AI",
        "name_orig": "TVOC Sensor Installed AI",
        "desc": "True: If  Sensor is installed.  False: If  Sensor is not installed.",
        "type": "enum",
        "min": "0",
        "max": "1",
        "res": "",
        "default": "0",
        "unit": "-",
        "options": {
            "0": "Off",
            "1": "Digital"
        }
    },
    "tvoc_sensor_installed_ar": {
        "id": "tvoc_sensor_installed_ar",
        "param_no": 10171,
        "parent": 47000,
        "name": "TVOC Sensor Installed AR",
        "name_orig": "TVOC Sensor Installed AR",
        "desc": "True: If  Sensor is installed.  False: If  Sensor is not installed.",
        "type": "enum",
        "min": "0",
        "max": "1",
        "res": "",
        "default": "0",
        "unit": "-",
        "options": {
            "0": "Off",
            "1": "Digital"
        }
    },
    "tvoc_sensor_installed_ae": {
        "id": "tvoc_sensor_installed_ae",
        "param_no": 10172,
        "parent": 47000,
        "name": "TVOC Sensor Installed AE",
        "name_orig": "TVOC Sensor Installed AE",
        "desc": "True: If  Sensor is installed.  False: If  Sensor is not installed.",
        "type": "enum",
        "min": "0",
        "max": "1",
        "res": "",
        "default": "0",
        "unit": "-",
        "options": {
            "0": "Off",
            "1": "Digital"
        }
    },
    "tvoc_sensor_installed_ao": {
        "id": "tvoc_sensor_installed_ao",
        "param_no": 10173,
        "parent": 47000,
        "name": "TVOC Sensor Installed AO",
        "name_orig": "TVOC Sensor Installed AO",
        "desc": "True: If  Sensor is installed.  False: If  Sensor is not installed.",
        "type": "enum",
        "min": "0",
        "max": "1",
        "res": "",
        "default": "0",
        "unit": "-",
        "options": {
            "0": "Off",
            "1": "Digital"
        }
    },
    "cds_lvl_sensor_sup_phe": {
        "id": "cds_lvl_sensor_sup_phe",
        "param_no": 10179,
        "parent": 48000,
        "name": "CDS Lvl Sensor Sup PHE",
        "name_orig": "CDS Lvl Sensor Sup PHE",
        "desc": "w. fb.: With Feedback, wo. fb.: Without Feedback, Where 'feedback' is a signal telling if the sensor is installed or not.",
        "type": "enum",
        "min": "0",
        "max": "7",
        "res": "",
        "default": "0",
        "unit": "-",
        "options": {
            "0": "Not Installed",
            "1": "Float Switch (NC)",
            "2": "Electrode Single Level Alarm High With Feedback",
            "3": "Electrode Single Level Alarm High Without Feedback",
            "4": "Electrode All Alarm Levels With Feedback",
            "5": "Electrode All Alarm Levels Without Feedback",
            "6": "Electrode Multi Level With Feedback",
            "7": "Electrode Multi Level Without Feedback"
        }
    },
    "cds_lvl_sensor_sup_ahe": {
        "id": "cds_lvl_sensor_sup_ahe",
        "param_no": 10180,
        "parent": 48000,
        "name": "CDS Lvl Sensor Sup AHE",
        "name_orig": "CDS Lvl Sensor Sup AHE",
        "desc": "w. fb.: With Feedback, wo. fb.: Without Feedback, Where 'feedback' is a signal telling if the sensor is installed or not.",
        "type": "enum",
        "min": "0",
        "max": "7",
        "res": "",
        "default": "0",
        "unit": "-",
        "options": {
            "0": "Not Installed",
            "1": "Float Switch (NC)",
            "2": "Electrode Single Level Alarm High With Feedback",
            "3": "Electrode Single Level Alarm High Without Feedback",
            "4": "Electrode All Alarm Levels With Feedback",
            "5": "Electrode All Alarm Levels Without Feedback",
            "6": "Electrode Multi Level With Feedback",
            "7": "Electrode Multi Level Without Feedback"
        }
    },
    "cds_lvl_sensor_ext_phe": {
        "id": "cds_lvl_sensor_ext_phe",
        "param_no": 10181,
        "parent": 48000,
        "name": "CDS Lvl Sensor Ext PHE",
        "name_orig": "CDS Lvl Sensor Ext PHE",
        "desc": "w. fb.: With Feedback, wo. fb.: Without Feedback, Where 'feedback' is a signal telling if the sensor is installed or not.",
        "type": "enum",
        "min": "0",
        "max": "7",
        "res": "",
        "default": "0",
        "unit": "-",
        "options": {
            "0": "Not Installed",
            "1": "Float Switch (NC)",
            "2": "Electrode Single Level Alarm High With Feedback",
            "3": "Electrode Single Level Alarm High Without Feedback",
            "4": "Electrode All Alarm Levels With Feedback",
            "5": "Electrode All Alarm Levels Without Feedback",
            "6": "Electrode Multi Level With Feedback",
            "7": "Electrode Multi Level Without Feedback"
        }
    },
    "cds_lvl_sensor_ext_ahe": {
        "id": "cds_lvl_sensor_ext_ahe",
        "param_no": 10182,
        "parent": 48000,
        "name": "CDS Lvl Sensor Ext AHE",
        "name_orig": "CDS Lvl Sensor Ext AHE",
        "desc": "w. fb.: With Feedback, wo. fb.: Without Feedback, Where 'feedback' is a signal telling if the sensor is installed or not.",
        "type": "enum",
        "min": "0",
        "max": "7",
        "res": "",
        "default": "0",
        "unit": "-",
        "options": {
            "0": "Not Installed",
            "1": "Float Switch (NC)",
            "2": "Electrode Single Level Alarm High With Feedback",
            "3": "Electrode Single Level Alarm High Without Feedback",
            "4": "Electrode All Alarm Levels With Feedback",
            "5": "Electrode All Alarm Levels Without Feedback",
            "6": "Electrode Multi Level With Feedback",
            "7": "Electrode Multi Level Without Feedback"
        }
    },
    "cds_lvl_sensor_threshold": {
        "id": "cds_lvl_sensor_threshold",
        "param_no": 10205,
        "parent": 48000,
        "name": "CDS Lvl Sensor Threshold",
        "name_orig": "CDS Lvl Sensor Threshold",
        "desc": "Threshold for the condensation level sensor, the sensor will trigger water level if this analog reading is reached.",
        "type": "int",
        "min": "0",
        "max": "255",
        "res": "",
        "default": "60",
        "unit": "-",
        "options": ""
    },
    "condensation_heating_pad_installed": {
        "id": "condensation_heating_pad_installed",
        "param_no": 10295,
        "parent": 48000,
        "name": "Condensation Heating Pad Installed",
        "name_orig": "Condensation Heating Pad Installed",
        "desc": "True: If Condensing Heating pad is installed.  False: If Condensing Heating Pad is not installed.",
        "type": "bool",
        "min": "0",
        "max": "0",
        "res": "",
        "default": "False",
        "unit": "-",
        "options": ""
    },
    "propane_sensor_installed": {
        "id": "propane_sensor_installed",
        "param_no": 10255,
        "parent": 49000,
        "name": "Propane Sensor Installed",
        "name_orig": "Propane Sensor Installed",
        "desc": "True: If Propane Sensor is installed.  False: If Propane Sensor is not installed.",
        "type": "bool",
        "min": "0",
        "max": "0",
        "res": "",
        "default": "False",
        "unit": "-",
        "options": ""
    },
    "motion_sensor_installed": {
        "id": "motion_sensor_installed",
        "param_no": 10272,
        "parent": 50000,
        "name": "Motion Sensor Installed",
        "name_orig": "Motion Sensor Installed",
        "desc": "True: If Motion Sensor is installed.  False: If Motion Sensor is not installed.",
        "type": "bool",
        "min": "0",
        "max": "0",
        "res": "",
        "default": "False",
        "unit": "-",
        "options": ""
    },
    "status_led_installed": {
        "id": "status_led_installed",
        "param_no": 10033,
        "parent": 51000,
        "name": "Status LED Installed",
        "name_orig": "Status LED Installed",
        "desc": "True: If Status LED is installed.  False: If Status LED is not installed.",
        "type": "bool",
        "min": "0",
        "max": "0",
        "res": "",
        "default": "False",
        "unit": "-",
        "options": ""
    },
    "cp_installed": {
        "id": "cp_installed",
        "param_no": 10329,
        "parent": 51000,
        "name": "Control Panel Installed",
        "name_orig": "Control Panel Installed",
        "desc": "True: If Control Panel is installed.  False: If Control Panel is not installed.",
        "type": "bool",
        "min": "0",
        "max": "0",
        "res": "",
        "default": "False",
        "unit": "-",
        "options": ""
    },
    "cp_orientation": {
        "id": "cp_orientation",
        "param_no": 10332,
        "parent": 51000,
        "name": "Control Panel Orientation",
        "name_orig": "Control Panel Orientation",
        "desc": "Physical orientation of the control panel - portrait or landscape (only relevant for Nova). This must be chosen before setting cp_installed to true.",
        "type": "enum",
        "min": "0",
        "max": "1",
        "res": "",
        "default": "1",
        "unit": "-",
        "options": {
            "0": "Landscape",
            "1": "Portrait"
        }
    },
    "analog_input_1": {
        "id": "analog_input_1",
        "param_no": 10256,
        "parent": 54000,
        "name": "Analog Input 1",
        "name_orig": "Analog Input 1",
        "desc": "",
        "type": "enum",
        "min": "0",
        "max": "3",
        "res": "",
        "default": "0",
        "unit": "-",
        "options": {
            "0": "None",
            "1": "CO2 Sensor",
            "2": "Motion Sensor",
            "3": "External Start"
        }
    },
    "analog_input_2": {
        "id": "analog_input_2",
        "param_no": 10257,
        "parent": 54000,
        "name": "Analog Input 2",
        "name_orig": "Analog Input 2",
        "desc": "",
        "type": "enum",
        "min": "0",
        "max": "3",
        "res": "",
        "default": "0",
        "unit": "-",
        "options": {
            "0": "None",
            "1": "CO2 Sensor",
            "2": "Motion Sensor",
            "3": "External Start"
        }
    },
    "analog_input_3": {
        "id": "analog_input_3",
        "param_no": 10258,
        "parent": 54000,
        "name": "Analog Input 3",
        "name_orig": "Analog Input 3",
        "desc": "",
        "type": "enum",
        "min": "0",
        "max": "3",
        "res": "",
        "default": "0",
        "unit": "-",
        "options": {
            "0": "None",
            "1": "CO2 Sensor",
            "2": "Motion Sensor",
            "3": "External Start"
        }
    },
    "analog_input_4": {
        "id": "analog_input_4",
        "param_no": 10259,
        "parent": 54000,
        "name": "Analog Input 4",
        "name_orig": "Analog Input 4",
        "desc": "",
        "type": "enum",
        "min": "0",
        "max": "3",
        "res": "",
        "default": "0",
        "unit": "-",
        "options": {
            "0": "None",
            "1": "CO2 Sensor",
            "2": "Motion Sensor",
            "3": "External Start"
        }
    },
    "analog_input_5": {
        "id": "analog_input_5",
        "param_no": 10260,
        "parent": 54000,
        "name": "Analog Input 5",
        "name_orig": "Analog Input 5",
        "desc": "",
        "type": "enum",
        "min": "0",
        "max": "3",
        "res": "",
        "default": "0",
        "unit": "-",
        "options": {
            "0": "None",
            "1": "CO2 Sensor",
            "2": "Motion Sensor",
            "3": "External Start"
        }
    },
    "external_analog_co2_ppm_range_min": {
        "id": "external_analog_co2_ppm_range_min",
        "param_no": 10261,
        "parent": 55000,
        "name": "External Analog CO2 Ppm Range Min",
        "name_orig": "External Analog CO2 Ppm Range Min",
        "desc": "Minimum CO2 concentration for the external CO2 sensor",
        "type": "int",
        "min": "0",
        "max": "10000",
        "res": "",
        "default": "0",
        "unit": "ppm",
        "options": ""
    },
    "external_analog_co2_ppm_range_max": {
        "id": "external_analog_co2_ppm_range_max",
        "param_no": 10262,
        "parent": 55000,
        "name": "External Analog CO2 Ppm Range Max",
        "name_orig": "External Analog CO2 Ppm Range Max",
        "desc": "Maximum CO2 concentration for the external CO2 sensor",
        "type": "int",
        "min": "0",
        "max": "10000",
        "res": "",
        "default": "10000",
        "unit": "ppm",
        "options": ""
    },
    "external_analog_co2_volt_range_min": {
        "id": "external_analog_co2_volt_range_min",
        "param_no": 10263,
        "parent": 55000,
        "name": "External Analog CO2 Volt Range Min",
        "name_orig": "External Analog CO2 Volt Range Min",
        "desc": "Minimum Volt for the external CO2 sensor",
        "type": "decimal",
        "min": "0.0",
        "max": "10.0",
        "res": "",
        "default": "0.0",
        "unit": "V",
        "options": ""
    },
    "external_analog_co2_volt_range_max": {
        "id": "external_analog_co2_volt_range_max",
        "param_no": 10264,
        "parent": 55000,
        "name": "External Analog CO2 Volt Range Max",
        "name_orig": "External Analog CO2 Volt Range Max",
        "desc": "Maximum Volt for the external CO2 sensor",
        "type": "decimal",
        "min": "0.0",
        "max": "10.0",
        "res": "",
        "default": "10.0",
        "unit": "V",
        "options": ""
    },
    "external_analog_motion_volt_threshold": {
        "id": "external_analog_motion_volt_threshold",
        "param_no": 10265,
        "parent": 56000,
        "name": "External Analog Motion Volt Threshold",
        "name_orig": "External Analog Motion Volt Threshold",
        "desc": "Threshold for the external motion sensor",
        "type": "decimal",
        "min": "0.0",
        "max": "10.0",
        "res": "",
        "default": "0.0",
        "unit": "V",
        "options": ""
    },
    "external_analog_motion_active_high": {
        "id": "external_analog_motion_active_high",
        "param_no": 10266,
        "parent": 56000,
        "name": "External Analog Motion Active High",
        "name_orig": "External Analog Motion Active High",
        "desc": "Active high for the external motion sensor",
        "type": "bool",
        "min": "0",
        "max": "0",
        "res": "",
        "default": "True",
        "unit": "-",
        "options": ""
    },
    "external_analog_start_volt_threshold": {
        "id": "external_analog_start_volt_threshold",
        "param_no": 10267,
        "parent": 57000,
        "name": "External Analog Start Volt Threshold",
        "name_orig": "External Analog Start Volt Threshold",
        "desc": "Threshold for the external start sensor",
        "type": "decimal",
        "min": "0.0",
        "max": "10.0",
        "res": "",
        "default": "0.0",
        "unit": "V",
        "options": ""
    },
    "external_analog_start_active_high": {
        "id": "external_analog_start_active_high",
        "param_no": 10268,
        "parent": 57000,
        "name": "External Analog Start Active High",
        "name_orig": "External Analog Start Active High",
        "desc": "Active high for the external start sensor",
        "type": "bool",
        "min": "0",
        "max": "0",
        "res": "",
        "default": "True",
        "unit": "-",
        "options": ""
    },
    "filter_test_mode": {
        "id": "filter_test_mode",
        "param_no": 10174,
        "parent": 59000,
        "name": "Filter Test Mode",
        "name_orig": "Filter Test Mode",
        "desc": "",
        "type": "enum",
        "min": "0",
        "max": "5",
        "res": "",
        "default": "0",
        "unit": "-",
        "options": {
            "0": "Off",
            "1": "Timer",
            "2": "Lifetime",
            "3": "Timer and Lifetime",
            "4": "Timer, Lifetime and Pressure",
            "5": "Pressure"
        }
    },
    "pre_filter_sup_hours_warning": {
        "id": "pre_filter_sup_hours_warning",
        "param_no": 10305,
        "parent": 60000,
        "name": "Pre-Filter Supply Hours Warning",
        "name_orig": "Pre-Filter Supply Hours Warning",
        "desc": "Time (in hours) before pre-filter supply warning",
        "type": "int",
        "min": "0",
        "max": "8760",
        "res": "",
        "default": "0",
        "unit": "hour",
        "options": ""
    },
    "pre_filter_sup_hours_alarm": {
        "id": "pre_filter_sup_hours_alarm",
        "param_no": 10306,
        "parent": 60000,
        "name": "Pre-Filter Supply Hours Alarm",
        "name_orig": "Pre-Filter Supply Hours Alarm",
        "desc": "Time (in hours) before pre-filter supply alarm",
        "type": "int",
        "min": "0",
        "max": "8760",
        "res": "",
        "default": "0",
        "unit": "hour",
        "options": ""
    },
    "pre_filter_sup_max_lifetime_warning_period": {
        "id": "pre_filter_sup_max_lifetime_warning_period",
        "param_no": 10307,
        "parent": 56000,
        "name": "Pre-Filter Supply Max Lifetime Warning Period",
        "name_orig": "Pre-Filter Supply Max Lifetime Warning Period",
        "desc": "Pre-filter supply warning period in months prior to alarm",
        "type": "int",
        "min": "0",
        "max": "12",
        "res": "",
        "default": "2",
        "unit": "month(s)",
        "options": ""
    },
    "pre_filter_sup_max_lifetime_warning": {
        "id": "pre_filter_sup_max_lifetime_warning",
        "param_no": 10333,
        "parent": 60000,
        "name": "Pre-Filter Supply Max Lifetime Warning",
        "name_orig": "Pre-Filter Supply Max Lifetime Warning",
        "desc": "Pre-filter supply warning when filter is this many months old (0 disables)",
        "type": "int",
        "min": "0",
        "max": "48",
        "res": "",
        "default": "22",
        "unit": "month(s)",
        "options": ""
    },
    "pre_filter_sup_max_lifetime_alarm": {
        "id": "pre_filter_sup_max_lifetime_alarm",
        "param_no": 10308,
        "parent": 60000,
        "name": "Pre-Filter Supply Max Lifetime Alarm",
        "name_orig": "Pre-Filter Supply Max Lifetime Alarm",
        "desc": "Pre-filter supply alarm when filter is this many months old (0 disables)",
        "type": "int",
        "min": "0",
        "max": "48",
        "res": "",
        "default": "24",
        "unit": "month(s)",
        "options": ""
    },
    "pre_filter_sup_rpm_warning_deviation_pct": {
        "id": "pre_filter_sup_rpm_warning_deviation_pct",
        "param_no": 10309,
        "parent": 60000,
        "name": "Pre-Filter Supply RPM Warning Deviation PCT",
        "name_orig": "Pre-Filter Supply RPM Warning Deviation PCT",
        "desc": "Pre-filter supply RPM warning deviation threshold as percentage",
        "type": "int",
        "min": "0",
        "max": "50",
        "res": "",
        "default": "10",
        "unit": "%",
        "options": ""
    },
    "pre_filter_sup_rpm_alarm_deviation_pct": {
        "id": "pre_filter_sup_rpm_alarm_deviation_pct",
        "param_no": 10310,
        "parent": 60000,
        "name": "Pre-Filter Supply RPM Alarm Deviation PCT",
        "name_orig": "Pre-Filter Supply RPM Alarm Deviation PCT",
        "desc": "Pre-filter supply RPM alarm deviation threshold as percentage",
        "type": "int",
        "min": "0",
        "max": "50",
        "res": "",
        "default": "20",
        "unit": "%",
        "options": ""
    },
    "pre_filter_ext_hours_warning": {
        "id": "pre_filter_ext_hours_warning",
        "param_no": 10311,
        "parent": 61000,
        "name": "Pre-Filter Extract Hours Warning",
        "name_orig": "Pre-Filter Extract Hours Warning",
        "desc": "Time (in hours) before pre-filter extract warning",
        "type": "int",
        "min": "0",
        "max": "8760",
        "res": "",
        "default": "0",
        "unit": "hour",
        "options": ""
    },
    "pre_filter_ext_hours_alarm": {
        "id": "pre_filter_ext_hours_alarm",
        "param_no": 10312,
        "parent": 61000,
        "name": "Pre-Filter Extract Hours Alarm",
        "name_orig": "Pre-Filter Extract Hours Alarm",
        "desc": "Time (in hours) before pre-filter extract alarm",
        "type": "int",
        "min": "0",
        "max": "8760",
        "res": "",
        "default": "0",
        "unit": "hour",
        "options": ""
    },
    "pre_filter_ext_max_lifetime_warning_period": {
        "id": "pre_filter_ext_max_lifetime_warning_period",
        "param_no": 10313,
        "parent": 57000,
        "name": "Pre-Filter Extract Max Lifetime Warning Period",
        "name_orig": "Pre-Filter Extract Max Lifetime Warning Period",
        "desc": "Pre-filter extract warning period in months prior to alarm",
        "type": "int",
        "min": "0",
        "max": "12",
        "res": "",
        "default": "2",
        "unit": "month(s)",
        "options": ""
    },
    "pre_filter_ext_max_lifetime_warning": {
        "id": "pre_filter_ext_max_lifetime_warning",
        "param_no": 10334,
        "parent": 61000,
        "name": "Pre-Filter Extract Max Lifetime Warning",
        "name_orig": "Pre-Filter Extract Max Lifetime Warning",
        "desc": "Pre-filter extract warning when filter is this many months old (0 disables)",
        "type": "int",
        "min": "0",
        "max": "48",
        "res": "",
        "default": "22",
        "unit": "month(s)",
        "options": ""
    },
    "pre_filter_ext_max_lifetime_alarm": {
        "id": "pre_filter_ext_max_lifetime_alarm",
        "param_no": 10314,
        "parent": 61000,
        "name": "Pre-Filter Extract Max Lifetime Alarm",
        "name_orig": "Pre-Filter Extract Max Lifetime Alarm",
        "desc": "Pre-filter extract alarm when filter is this many months old (0 disables)",
        "type": "int",
        "min": "0",
        "max": "48",
        "res": "",
        "default": "24",
        "unit": "month(s)",
        "options": ""
    },
    "pre_filter_ext_rpm_warning_deviation_pct": {
        "id": "pre_filter_ext_rpm_warning_deviation_pct",
        "param_no": 10315,
        "parent": 61000,
        "name": "Pre-Filter Extract RPM Warning Deviation PCT",
        "name_orig": "Pre-Filter Extract RPM Warning Deviation PCT",
        "desc": "Pre-filter extract RPM warning deviation threshold as percentage",
        "type": "int",
        "min": "0",
        "max": "50",
        "res": "",
        "default": "10",
        "unit": "%",
        "options": ""
    },
    "pre_filter_ext_rpm_alarm_deviation_pct": {
        "id": "pre_filter_ext_rpm_alarm_deviation_pct",
        "param_no": 10316,
        "parent": 61000,
        "name": "Pre-Filter Extract RPM Alarm Deviation PCT",
        "name_orig": "Pre-Filter Extract RPM Alarm Deviation PCT",
        "desc": "Pre-filter extract RPM alarm deviation threshold as percentage",
        "type": "int",
        "min": "0",
        "max": "50",
        "res": "",
        "default": "20",
        "unit": "%",
        "options": ""
    },
    "main_filter_sup_hours_warning": {
        "id": "main_filter_sup_hours_warning",
        "param_no": 10317,
        "parent": 62000,
        "name": "Main Filter Supply Hours Warning",
        "name_orig": "Main Filter Supply Hours Warning",
        "desc": "Time (in hours) before main filter supply warning",
        "type": "int",
        "min": "0",
        "max": "8760",
        "res": "",
        "default": "0",
        "unit": "hour",
        "options": ""
    },
    "main_filter_sup_hours_alarm": {
        "id": "main_filter_sup_hours_alarm",
        "param_no": 10318,
        "parent": 62000,
        "name": "Main Filter Supply Hours Alarm",
        "name_orig": "Main Filter Supply Hours Alarm",
        "desc": "Time (in hours) before main filter supply alarm",
        "type": "int",
        "min": "0",
        "max": "8760",
        "res": "",
        "default": "0",
        "unit": "hour",
        "options": ""
    },
    "main_filter_sup_max_lifetime_warning_period": {
        "id": "main_filter_sup_max_lifetime_warning_period",
        "param_no": 10319,
        "parent": 58000,
        "name": "Main Filter Supply Max Lifetime Warning Period",
        "name_orig": "Main Filter Supply Max Lifetime Warning Period",
        "desc": "Main filter supply warning period in months prior to alarm",
        "type": "int",
        "min": "0",
        "max": "12",
        "res": "",
        "default": "2",
        "unit": "month(s)",
        "options": ""
    },
    "main_filter_sup_max_lifetime_warning": {
        "id": "main_filter_sup_max_lifetime_warning",
        "param_no": 10335,
        "parent": 62000,
        "name": "Main Filter Supply Max Lifetime Warning",
        "name_orig": "Main Filter Supply Max Lifetime Warning",
        "desc": "Main filter supply warning when filter is this many months old (0 disables)",
        "type": "int",
        "min": "0",
        "max": "48",
        "res": "",
        "default": "22",
        "unit": "month(s)",
        "options": ""
    },
    "main_filter_sup_max_lifetime_alarm": {
        "id": "main_filter_sup_max_lifetime_alarm",
        "param_no": 10320,
        "parent": 62000,
        "name": "Main Filter Supply Max Lifetime Alarm",
        "name_orig": "Main Filter Supply Max Lifetime Alarm",
        "desc": "Main filter supply alarm when filter is this many months old (0 disables)",
        "type": "int",
        "min": "0",
        "max": "48",
        "res": "",
        "default": "24",
        "unit": "month(s)",
        "options": ""
    },
    "main_filter_sup_rpm_warning_deviation_pct": {
        "id": "main_filter_sup_rpm_warning_deviation_pct",
        "param_no": 10321,
        "parent": 62000,
        "name": "Main Filter Supply RPM Warning Deviation PCT",
        "name_orig": "Main Filter Supply RPM Warning Deviation PCT",
        "desc": "Main filter supply RPM warning deviation threshold as percentage",
        "type": "int",
        "min": "0",
        "max": "50",
        "res": "",
        "default": "10",
        "unit": "%",
        "options": ""
    },
    "main_filter_sup_rpm_alarm_deviation_pct": {
        "id": "main_filter_sup_rpm_alarm_deviation_pct",
        "param_no": 10322,
        "parent": 62000,
        "name": "Main Filter Supply RPM Alarm Deviation PCT",
        "name_orig": "Main Filter Supply RPM Alarm Deviation PCT",
        "desc": "Main filter supply RPM alarm deviation threshold as percentage",
        "type": "int",
        "min": "0",
        "max": "50",
        "res": "",
        "default": "20",
        "unit": "%",
        "options": ""
    },
    "main_filter_ext_hours_warning": {
        "id": "main_filter_ext_hours_warning",
        "param_no": 10323,
        "parent": 63000,
        "name": "Main Filter Extract Hours Warning",
        "name_orig": "Main Filter Extract Hours Warning",
        "desc": "Time (in hours) before main filter extract warning",
        "type": "int",
        "min": "0",
        "max": "8760",
        "res": "",
        "default": "0",
        "unit": "hour",
        "options": ""
    },
    "main_filter_ext_hours_alarm": {
        "id": "main_filter_ext_hours_alarm",
        "param_no": 10324,
        "parent": 63000,
        "name": "Main Filter Extract Hours Alarm",
        "name_orig": "Main Filter Extract Hours Alarm",
        "desc": "Time (in hours) before main filter extract alarm",
        "type": "int",
        "min": "0",
        "max": "8760",
        "res": "",
        "default": "0",
        "unit": "hour",
        "options": ""
    },
    "main_filter_ext_max_lifetime_warning_period": {
        "id": "main_filter_ext_max_lifetime_warning_period",
        "param_no": 10325,
        "parent": 59000,
        "name": "Main Filter Extract Max Lifetime Warning Period",
        "name_orig": "Main Filter Extract Max Lifetime Warning Period",
        "desc": "Main filter extract warning period in months prior to alarm",
        "type": "int",
        "min": "0",
        "max": "12",
        "res": "",
        "default": "2",
        "unit": "month(s)",
        "options": ""
    },
    "main_filter_ext_max_lifetime_warning": {
        "id": "main_filter_ext_max_lifetime_warning",
        "param_no": 10336,
        "parent": 63000,
        "name": "Main Filter Extract Max Lifetime Warning",
        "name_orig": "Main Filter Extract Max Lifetime Warning",
        "desc": "Main filter extract warning when filter is this many months old (0 disables)",
        "type": "int",
        "min": "0",
        "max": "48",
        "res": "",
        "default": "22",
        "unit": "month(s)",
        "options": ""
    },
    "main_filter_ext_max_lifetime_alarm": {
        "id": "main_filter_ext_max_lifetime_alarm",
        "param_no": 10326,
        "parent": 63000,
        "name": "Main Filter Extract Max Lifetime Alarm",
        "name_orig": "Main Filter Extract Max Lifetime Alarm",
        "desc": "Main filter extract alarm when filter is this many months old (0 disables)",
        "type": "int",
        "min": "0",
        "max": "48",
        "res": "",
        "default": "24",
        "unit": "month(s)",
        "options": ""
    },
    "main_filter_ext_rpm_warning_deviation_pct": {
        "id": "main_filter_ext_rpm_warning_deviation_pct",
        "param_no": 10327,
        "parent": 63000,
        "name": "Main Filter Extract RPM Warning Deviation PCT",
        "name_orig": "Main Filter Extract RPM Warning Deviation PCT",
        "desc": "Main filter extract RPM warning deviation threshold as percentage",
        "type": "int",
        "min": "0",
        "max": "50",
        "res": "",
        "default": "10",
        "unit": "%",
        "options": ""
    },
    "main_filter_ext_rpm_alarm_deviation_pct": {
        "id": "main_filter_ext_rpm_alarm_deviation_pct",
        "param_no": 10328,
        "parent": 63000,
        "name": "Main Filter Extract RPM Alarm Deviation PCT",
        "name_orig": "Main Filter Extract RPM Alarm Deviation PCT",
        "desc": "Main filter extract RPM alarm deviation threshold as percentage",
        "type": "int",
        "min": "0",
        "max": "50",
        "res": "",
        "default": "20",
        "unit": "%",
        "options": ""
    },
    "nominal_max_flow": {
        "id": "nominal_max_flow",
        "param_no": 10186,
        "parent": 64000,
        "name": "Nominal Max Flow",
        "name_orig": "Nominal Max Flow",
        "desc": "Nominal max flow of the unit",
        "type": "decimal",
        "min": "0.0",
        "max": "2000.0",
        "res": "",
        "default": "0.0",
        "unit": "m3/h",
        "options": ""
    },
    "flow_control_mode": {
        "id": "flow_control_mode",
        "param_no": 10183,
        "parent": 65000,
        "name": "Flow Control Mode",
        "name_orig": "Flow Control Mode",
        "desc": "Select Flow Mode: Ventilator voltage percentage / PID flow controller",
        "type": "enum",
        "min": "0",
        "max": "2",
        "res": "",
        "default": "1",
        "unit": "-",
        "options": {
            "0": "Flow Control",
            "1": "Voltage Control",
            "2": "Voltage Direct"
        }
    },
    "supply_fan_flow_calibration": {
        "id": "supply_fan_flow_calibration",
        "param_no": 10184,
        "parent": 66000,
        "name": "Supply Fan Flow Calibration",
        "name_orig": "Supply Fan Flow Calibration",
        "desc": "Supply Fan Flow Calibration",
        "type": "decimal",
        "min": "-100.0",
        "max": "100.0",
        "res": "",
        "default": "0.0",
        "unit": "%",
        "options": ""
    },
    "extraction_fan_flow_calibration": {
        "id": "extraction_fan_flow_calibration",
        "param_no": 10185,
        "parent": 66000,
        "name": "Extraction Fan Flow Calibration",
        "name_orig": "Extraction Fan Flow Calibration",
        "desc": "Extraction Fan Flow Calibration",
        "type": "decimal",
        "min": "-100.0",
        "max": "100.0",
        "res": "",
        "default": "0.0",
        "unit": "%",
        "options": ""
    },
    "draft_strat_algo_enabled": {
        "id": "draft_strat_algo_enabled",
        "param_no": 10201,
        "parent": 67000,
        "name": "Draft and strat algorithm enabled",
        "name_orig": "Draft and strat algorithm enabled",
        "desc": "Enable or disable the draft and stratification algorithm",
        "type": "bool",
        "min": "0",
        "max": "0",
        "res": "",
        "default": "False",
        "unit": "-",
        "options": ""
    },
    "min_inlet_damper_pos": {
        "id": "min_inlet_damper_pos",
        "param_no": 10202,
        "parent": 68000,
        "name": "Minimum inlet damper position.",
        "name_orig": "Minimum inlet damper position.",
        "desc": "Set the lower limit of the position of the inlet damper in percentage",
        "type": "decimal",
        "min": "0.0",
        "max": "100.0",
        "res": "",
        "default": "0.0",
        "unit": "%",
        "options": ""
    },
    "max_inlet_damper_pos": {
        "id": "max_inlet_damper_pos",
        "param_no": 10203,
        "parent": 68000,
        "name": "Maximum inlet damper position.",
        "name_orig": "Maximum inlet damper position.",
        "desc": "Set the upper limit of the position of the inlet damper in percentage",
        "type": "decimal",
        "min": "0.0",
        "max": "100.0",
        "res": "",
        "default": "100.0",
        "unit": "%",
        "options": ""
    },
    "manufacturer_id": {
        "id": "manufacturer_id",
        "param_no": 10187,
        "parent": 69000,
        "name": "Manufacturer ID",
        "name_orig": "Manufacturer ID",
        "desc": "",
        "type": "enum",
        "min": "0",
        "max": "13",
        "res": "",
        "default": "0",
        "unit": "",
        "options": {
            "0": "None",
            "1": "Airmaster AS",
            "2": "Airmaster AB",
            "3": "Airmaster Ltd",
            "4": "Airmaster AS 4",
            "5": "Helios Ventilateurs",
            "6": "Wesco AG",
            "7": "Airmaster B.V",
            "8": "SAV Systems Ltd.",
            "9": "Airflow Lufttechnik GmbH",
            "10": "Johann WERNIG KG",
            "11": "Airmaster Norge AS",
            "12": "Airmaster Norge AS 12",
            "13": "Airmaster AS 13"
        }
    },
    "manufacturer_phone": {
        "id": "manufacturer_phone",
        "param_no": 10188,
        "parent": 69000,
        "name": "Manufacturer Phone",
        "name_orig": "Manufacturer Phone",
        "desc": "",
        "type": "string",
        "min": "0",
        "max": "0",
        "res": "",
        "default": "-",
        "unit": "-",
        "options": ""
    },
    "support_id": {
        "id": "support_id",
        "param_no": 10189,
        "parent": 69000,
        "name": "Support ID",
        "name_orig": "Support ID",
        "desc": "",
        "type": "enum",
        "min": "0",
        "max": "13",
        "res": "",
        "default": "0",
        "unit": "",
        "options": {
            "0": "None",
            "1": "Airmaster AS",
            "2": "Airmaster AB",
            "3": "Airmaster Ltd.",
            "4": "Airmaster AS Duplicate",
            "5": "Helios Ventilateurs",
            "6": "Wesco AG",
            "7": "Itho Daalderop",
            "8": "SAV Systems Ltd.",
            "9": "Airflow Lufttechnik GmbH",
            "10": "Johann WERNIG KG",
            "11": "Sandviken Center Ventilasjonsservice AS",
            "12": "Airmaster AS Norge",
            "13": "AT-Air OY"
        }
    },
    "support_phone": {
        "id": "support_phone",
        "param_no": 10190,
        "parent": 69000,
        "name": "Support Phone",
        "name_orig": "Support Phone",
        "desc": "",
        "type": "string",
        "min": "0",
        "max": "0",
        "res": "",
        "default": "-",
        "unit": "-",
        "options": ""
    },
    "udf": {
        "id": "udf",
        "parent": 0,
        "name": "User Defined Air Flow",
        "name_orig": "User Defined Air Flow",
        "desc": "User Defined Air Flow",
        "type": "decimal",
        "min": 0,
        "max": 100,
        "res": "0.01",
        "format": "%.1f",
        "unit": "%"
    },
    "rqf": {
        "id": "rqf",
        "parent": 0,
        "name": "Requested Flow",
        "name_orig": "Requested Flow",
        "desc": "Requested Flow",
        "type": "decimal",
        "min": 0,
        "max": 100,
        "res": "0.01",
        "format": "%.1f",
        "unit": "%"
    },
    "udt": {
        "id": "udt",
        "parent": 0,
        "name": "User Defined Temperature",
        "name_orig": "User Defined Temperature",
        "desc": "User Defined Temperature",
        "type": "decimal",
        "min": -100,
        "max": 100,
        "res": "0.01",
        "format": "%.1f",
        "unit": "°C"
    },
    "rqt": {
        "id": "rqt",
        "parent": 0,
        "name": "Requested Temperature",
        "name_orig": "Requested Temperature",
        "desc": "Requested Temperature",
        "type": "decimal",
        "min": -100,
        "max": 100,
        "res": "0.01",
        "format": "%.1f",
        "unit": "°C"
    },
    "trt": {
        "id": "trt",
        "parent": 0,
        "name": "Target Room Temperature",
        "name_orig": "Target Room Temperature",
        "desc": "Target Room Temperature",
        "type": "decimal",
        "min": -100,
        "max": 100,
        "res": "0.01",
        "format": "%.1f",
        "unit": "°C"
    }
}

export const awareParamNames = {
    "min_flow_setpoint": "min_flow_setpoint",
    "max_flow_setpoint": "max_flow_setpoint",
    "summer_period_trt_heating": "summer_period_trt_heating",
    "summer_period_trt_cooling": "summer_period_trt_cooling",
    "summer_period_active_cooling_allowed": "summer_period_active_cooling_allowed",
    "summer_period_active_heating_allowed": "summer_period_active_heating_allowed",
    "summer_period_start_date": "summer_period_start_date",
    "summer_period_max_rqt": "summer_period_max_rqt",
    "summer_period_min_rqt": "summer_period_min_rqt",
    "winter_period_trt_heating": "winter_period_trt_heating",
    "winter_period_trt_cooling": "winter_period_trt_cooling",
    "winter_period_active_cooling_allowed": "winter_period_active_cooling_allowed",
    "winter_period_active_heating_allowed": "winter_period_active_heating_allowed",
    "winter_period_start_date": "winter_period_start_date",
    "winter_period_max_rqt": "winter_period_max_rqt",
    "winter_period_min_rqt": "winter_period_min_rqt",
    "co2_control_enabled": "co2_control_enabled",
    "co2_control_min": "co2_control_min",
    "co2_control_max": "co2_control_max",
    "co2_control_multiple_sensor_mode": "co2_control_multiple_sensor_mode",
    "night_cooling_trt": "night_cooling_trt",
    "night_cooling_max_flow_scaling": "night_cooling_max_flow_scaling",
    "night_cooling_min_inlet_temp": "night_cooling_min_inlet_temp",
    "night_cooling_min_temp_difference": "night_cooling_min_temp_difference",
    "night_cooling_active_allowed": "night_cooling_active_allowed",
    "extern_start_delay_time": "extern_start_delay_time",
    "extern_start_afterrun_timer": "extern_start_afterrun_timer",
    "extern_start_auto_off_timer": "extern_start_auto_off_timer",
    "motion_start_delay_time": "motion_start_delay_time",
    "motion_afterrun_timer": "motion_afterrun_timer",
    "start_priority_1": "start_priority_1",
    "start_priority_2": "start_priority_2",
    "start_priority_3": "start_priority_3",
    "start_priority_4": "start_priority_4",
    "start_priority_5": "start_priority_5",
    "start_priority_6": "start_priority_6",
    "start_priority_dependency": "start_priority_dependency",
    "timer_schedule_0_enabled": "timer_schedule_0_enabled",
    "timer_schedule_0_mode": "timer_schedule_0_mode",
    "timer_schedule_0_days": "timer_schedule_0_days",
    "timer_schedule_0_start_time": "timer_schedule_0_start_time",
    "timer_schedule_0_duration": "timer_schedule_0_duration",
    "timer_schedule_1_enabled": "timer_schedule_1_enabled",
    "timer_schedule_1_mode": "timer_schedule_1_mode",
    "timer_schedule_1_days": "timer_schedule_1_days",
    "timer_schedule_1_start_time": "timer_schedule_1_start_time",
    "timer_schedule_1_duration": "timer_schedule_1_duration",
    "timer_schedule_2_enabled": "timer_schedule_2_enabled",
    "timer_schedule_2_mode": "timer_schedule_2_mode",
    "timer_schedule_2_days": "timer_schedule_2_days",
    "timer_schedule_2_start_time": "timer_schedule_2_start_time",
    "timer_schedule_2_duration": "timer_schedule_2_duration",
    "timer_schedule_3_enabled": "timer_schedule_3_enabled",
    "timer_schedule_3_mode": "timer_schedule_3_mode",
    "timer_schedule_3_days": "timer_schedule_3_days",
    "timer_schedule_3_start_time": "timer_schedule_3_start_time",
    "timer_schedule_3_duration": "timer_schedule_3_duration",
    "timer_schedule_4_enabled": "timer_schedule_4_enabled",
    "timer_schedule_4_mode": "timer_schedule_4_mode",
    "timer_schedule_4_days": "timer_schedule_4_days",
    "timer_schedule_4_start_time": "timer_schedule_4_start_time",
    "timer_schedule_4_duration": "timer_schedule_4_duration",
    "timer_schedule_5_enabled": "timer_schedule_5_enabled",
    "timer_schedule_5_mode": "timer_schedule_5_mode",
    "timer_schedule_5_days": "timer_schedule_5_days",
    "timer_schedule_5_start_time": "timer_schedule_5_start_time",
    "timer_schedule_5_duration": "timer_schedule_5_duration",
    "timer_schedule_6_enabled": "timer_schedule_6_enabled",
    "timer_schedule_6_mode": "timer_schedule_6_mode",
    "timer_schedule_6_days": "timer_schedule_6_days",
    "timer_schedule_6_start_time": "timer_schedule_6_start_time",
    "timer_schedule_6_duration": "timer_schedule_6_duration",
    "timer_schedule_7_enabled": "timer_schedule_7_enabled",
    "timer_schedule_7_mode": "timer_schedule_7_mode",
    "timer_schedule_7_days": "timer_schedule_7_days",
    "timer_schedule_7_start_time": "timer_schedule_7_start_time",
    "timer_schedule_7_duration": "timer_schedule_7_duration",
    "timer_schedule_8_enabled": "timer_schedule_8_enabled",
    "timer_schedule_8_mode": "timer_schedule_8_mode",
    "timer_schedule_8_days": "timer_schedule_8_days",
    "timer_schedule_8_start_time": "timer_schedule_8_start_time",
    "timer_schedule_8_duration": "timer_schedule_8_duration",
    "time_zone": "time_zone",
    "unit_name": "unit_name",
    "forced_standby_time": "forced_standby_time",
    "boost_ventilation_mode_time": "boost_ventilation_mode_time",
    "low_noise_mode_time": "low_noise_mode_time",
    "manual_override_time": "manual_override_time",
    "min_temp_setpoint": "min_temp_setpoint",
    "max_temp_setpoint": "max_temp_setpoint",
    "cp_screen_lock_enabled_filter": "cp_screen_lock_enabled_filter",
    "cp_screen_lock_enabled_wifi_ap": "cp_screen_lock_enabled_wifi_ap",
    "cp_screen_lock_enabled_standby": "cp_screen_lock_enabled_standby",
    "cp_screen_lock_enabled_setpoints": "cp_screen_lock_enabled_setpoints",
    "cp_screen_lock_enabled_reboot": "cp_screen_lock_enabled_reboot",
    "cp_screen_lock_pin_code": "cp_screen_lock_pin_code",
    "cp_manual_mode_allowed": "cp_manual_mode_allowed",
    "cp_flow_modes_allowed": "cp_flow_modes_allowed",
    "status_led_on_when_running_normal": "status_led_on_when_running_normal",
    "status_led_on_when_not_running_normal": "status_led_on_when_not_running_normal",
    "wifi_ap_enabled_after_power_on": "wifi_ap_enabled_after_power_on",
    "wifi_ap_auto_off_timer": "wifi_ap_auto_off_timer",
    "modbus_tcp_ip_enabled": "modbus_tcp_ip_enabled",
    "modbus_tcp_ip_option_installed": "modbus_tcp_ip_option_installed",
    "modem_4g_installed": "modem_4g_installed",
    "am_unit_type": "am_unit_type",
    "ccm_installed": "ccm_installed",
    "co2_sensor_installed_ai": "co2_sensor_installed_ai",
    "co2_sensor_installed_ar": "co2_sensor_installed_ar",
    "co2_sensor_installed_ae": "co2_sensor_installed_ae",
    "co2_sensor_installed_ao": "co2_sensor_installed_ao",
    "analog_co2_sensor_ppm_range_min": "analog_co2_sensor_ppm_range_min",
    "analog_co2_sensor_ppm_range_max": "analog_co2_sensor_ppm_range_max",
    "analog_co2_sensor_volt_range_min": "analog_co2_sensor_volt_range_min",
    "analog_co2_sensor_volt_range_max": "analog_co2_sensor_volt_range_max",
    "aa_mode": "aa_mode",
    "aa_run_time": "aa_run_time",
    "aa_upward_direction": "aa_upward_direction",
    "aa_cw_rotation": "aa_cw_rotation",
    "aa_ccw_rotation": "aa_ccw_rotation",
    "bp_mode": "bp_mode",
    "bp_run_time": "bp_run_time",
    "bp_open_direction": "bp_open_direction",
    "bp_cw_rotation": "bp_cw_rotation",
    "bp_ccw_rotation": "bp_ccw_rotation",
    "mds_mode": "mds_mode",
    "mds_run_time": "mds_run_time",
    "mds_open_direction": "mds_open_direction",
    "mds_cw_rotation": "mds_cw_rotation",
    "mds_ccw_rotation": "mds_ccw_rotation",
    "mde_mode": "mde_mode",
    "mde_run_time": "mde_run_time",
    "mde_open_direction": "mde_open_direction",
    "mde_cw_rotation": "mde_cw_rotation",
    "mde_ccw_rotation": "mde_ccw_rotation",
    "md_min_opening": "md_min_opening",
    "rci_mode": "rci_mode",
    "rci_run_time": "rci_run_time",
    "rci_open_direction": "rci_open_direction",
    "rci_cw_rotation": "rci_cw_rotation",
    "rci_ccw_rotation": "rci_ccw_rotation",
    "rco_mode": "rco_mode",
    "rco_run_time": "rco_run_time",
    "rco_open_direction": "rco_open_direction",
    "rco_cw_rotation": "rco_cw_rotation",
    "rco_ccw_rotation": "rco_ccw_rotation",
    "fan_supply_min_pct": "fan_supply_min_pct",
    "fan_supply_vent_max_pct": "fan_supply_vent_max_pct",
    "fan_supply_recirc_max_pct": "fan_supply_recirc_max_pct",
    "fan_extraction_min_pct": "fan_extraction_min_pct",
    "fan_extraction_vent_max_pct": "fan_extraction_vent_max_pct",
    "fan_extraction_recirc_max_pct": "fan_extraction_recirc_max_pct",
    "pre_heater_installed": "pre_heater_installed",
    "rh_sensor_installed_ai": "rh_sensor_installed_ai",
    "rh_sensor_installed_ar": "rh_sensor_installed_ar",
    "rh_sensor_installed_ae": "rh_sensor_installed_ae",
    "rh_sensor_installed_ao": "rh_sensor_installed_ao",
    "analog_rh_sensor_pct_range_min": "analog_rh_sensor_pct_range_min",
    "analog_rh_sensor_pct_range_max": "analog_rh_sensor_pct_range_max",
    "analog_rh_sensor_volt_range_min": "analog_rh_sensor_volt_range_min",
    "analog_rh_sensor_volt_range_max": "analog_rh_sensor_volt_range_max",
    "hvac_mode": "hvac_mode",
    "hvac_eev_installed": "hvac_eev_installed",
    "hvac_eev_steps": "hvac_eev_steps",
    "hvac_eev_calibration_steps": "hvac_eev_calibration_steps",
    "hvac_eev_calibration_time": "hvac_eev_calibration_time",
    "hvac_four_way_valve_active": "hvac_four_way_valve_active",
    "hvac_fc_power_mode": "hvac_fc_power_mode",
    "pressure_switch_installed_vic": "pressure_switch_installed_vic",
    "pressure_switch_installed_voc": "pressure_switch_installed_voc",
    "pressure_transmitter_installed_vti": "pressure_transmitter_installed_vti",
    "pressure_transmitter_installed_lbi": "pressure_transmitter_installed_lbi",
    "pressure_transmitter_installed_vto": "pressure_transmitter_installed_vto",
    "pressure_transmitter_installed_lbo": "pressure_transmitter_installed_lbo",
    "pressure_transmitter_installed_vic": "pressure_transmitter_installed_vic",
    "analog_v_pressure_transmitter_bar_range_min": "analog_v_pressure_transmitter_bar_range_min",
    "analog_v_pressure_transmitter_bar_range_max": "analog_v_pressure_transmitter_bar_range_max",
    "analog_v_pressure_transmitter_volt_range_min": "analog_v_pressure_transmitter_volt_range_min",
    "analog_v_pressure_transmitter_volt_range_max": "analog_v_pressure_transmitter_volt_range_max",
    "analog_i_pressure_transmitter_bar_range_min": "analog_i_pressure_transmitter_bar_range_min",
    "analog_i_pressure_transmitter_bar_range_max": "analog_i_pressure_transmitter_bar_range_max",
    "analog_i_pressure_transmitter_ma_range_min": "analog_i_pressure_transmitter_ma_range_min",
    "analog_i_pressure_transmitter_ma_range_max": "analog_i_pressure_transmitter_ma_range_max",
    "t_sensor_installed_ai": "t_sensor_installed_ai",
    "t_sensor_installed_ar": "t_sensor_installed_ar",
    "t_sensor_installed_ae": "t_sensor_installed_ae",
    "t_sensor_installed_ao": "t_sensor_installed_ao",
    "t_sensor_installed_aop": "t_sensor_installed_aop",
    "t_sensor_installed_aio": "t_sensor_installed_aio",
    "t_sensor_installed_aii": "t_sensor_installed_aii",
    "t_sensor_installed_vto": "t_sensor_installed_vto",
    "t_sensor_installed_vti": "t_sensor_installed_vti",
    "t_sensor_installed_voc": "t_sensor_installed_voc",
    "t_sensor_installed_lbo": "t_sensor_installed_lbo",
    "t_sensor_installed_lbi": "t_sensor_installed_lbi",
    "t_sensor_installed_lie": "t_sensor_installed_lie",
    "t_sensor_installed_loe": "t_sensor_installed_loe",
    "t_sensor_installed_pci": "t_sensor_installed_pci",
    "t_sensor_installed_pco": "t_sensor_installed_pco",
    "t_sensor_installed_vic": "t_sensor_installed_vic",
    "tvoc_sensor_installed_ai": "tvoc_sensor_installed_ai",
    "tvoc_sensor_installed_ar": "tvoc_sensor_installed_ar",
    "tvoc_sensor_installed_ae": "tvoc_sensor_installed_ae",
    "tvoc_sensor_installed_ao": "tvoc_sensor_installed_ao",
    "cds_lvl_sensor_sup_phe": "cds_lvl_sensor_sup_phe",
    "cds_lvl_sensor_sup_ahe": "cds_lvl_sensor_sup_ahe",
    "cds_lvl_sensor_ext_phe": "cds_lvl_sensor_ext_phe",
    "cds_lvl_sensor_ext_ahe": "cds_lvl_sensor_ext_ahe",
    "cds_lvl_sensor_threshold": "cds_lvl_sensor_threshold",
    "condensation_heating_pad_installed": "condensation_heating_pad_installed",
    "propane_sensor_installed": "propane_sensor_installed",
    "motion_sensor_installed": "motion_sensor_installed",
    "status_led_installed": "status_led_installed",
    "cp_installed": "cp_installed",
    "cp_orientation": "cp_orientation",
    "analog_input_1": "analog_input_1",
    "analog_input_2": "analog_input_2",
    "analog_input_3": "analog_input_3",
    "analog_input_4": "analog_input_4",
    "analog_input_5": "analog_input_5",
    "external_analog_co2_ppm_range_min": "external_analog_co2_ppm_range_min",
    "external_analog_co2_ppm_range_max": "external_analog_co2_ppm_range_max",
    "external_analog_co2_volt_range_min": "external_analog_co2_volt_range_min",
    "external_analog_co2_volt_range_max": "external_analog_co2_volt_range_max",
    "external_analog_motion_volt_threshold": "external_analog_motion_volt_threshold",
    "external_analog_motion_active_high": "external_analog_motion_active_high",
    "external_analog_start_volt_threshold": "external_analog_start_volt_threshold",
    "external_analog_start_active_high": "external_analog_start_active_high",
    "filter_test_mode": "filter_test_mode",
    "pre_filter_sup_hours_warning": "pre_filter_sup_hours_warning",
    "pre_filter_sup_hours_alarm": "pre_filter_sup_hours_alarm",
    "pre_filter_sup_max_lifetime_warning": "pre_filter_sup_max_lifetime_warning",
    "pre_filter_sup_max_lifetime_warning_period": "pre_filter_sup_max_lifetime_warning_period",
    "pre_filter_sup_max_lifetime_alarm": "pre_filter_sup_max_lifetime_alarm",
    "pre_filter_sup_rpm_warning_deviation_pct": "pre_filter_sup_rpm_warning_deviation_pct",
    "pre_filter_sup_rpm_alarm_deviation_pct": "pre_filter_sup_rpm_alarm_deviation_pct",
    "pre_filter_ext_hours_warning": "pre_filter_ext_hours_warning",
    "pre_filter_ext_hours_alarm": "pre_filter_ext_hours_alarm",
    "pre_filter_ext_max_lifetime_warning": "pre_filter_ext_max_lifetime_warning",
    "pre_filter_ext_max_lifetime_warning_period": "pre_filter_ext_max_lifetime_warning_period",
    "pre_filter_ext_max_lifetime_alarm": "pre_filter_ext_max_lifetime_alarm",
    "pre_filter_ext_rpm_warning_deviation_pct": "pre_filter_ext_rpm_warning_deviation_pct",
    "pre_filter_ext_rpm_alarm_deviation_pct": "pre_filter_ext_rpm_alarm_deviation_pct",
    "main_filter_sup_hours_warning": "main_filter_sup_hours_warning",
    "main_filter_sup_hours_alarm": "main_filter_sup_hours_alarm",
    "main_filter_sup_max_lifetime_warning": "main_filter_sup_max_lifetime_warning",
    "main_filter_sup_max_lifetime_alarm": "main_filter_sup_max_lifetime_alarm",
    "main_filter_sup_rpm_warning_deviation_pct": "main_filter_sup_rpm_warning_deviation_pct",
    "main_filter_sup_rpm_alarm_deviation_pct": "main_filter_sup_rpm_alarm_deviation_pct",
    "main_filter_ext_hours_warning": "main_filter_ext_hours_warning",
    "main_filter_ext_hours_alarm": "main_filter_ext_hours_alarm",
    "main_filter_ext_max_lifetime_warning": "main_filter_ext_max_lifetime_warning",
    "main_filter_ext_max_lifetime_warning_period": "main_filter_ext_max_lifetime_warning_period",
    "main_filter_ext_max_lifetime_alarm": "main_filter_ext_max_lifetime_alarm",
    "main_filter_ext_rpm_warning_deviation_pct": "main_filter_ext_rpm_warning_deviation_pct",
    "main_filter_ext_rpm_alarm_deviation_pct": "main_filter_ext_rpm_alarm_deviation_pct",
    "nominal_max_flow": "nominal_max_flow",
    "flow_control_mode": "flow_control_mode",
    "supply_fan_flow_calibration": "supply_fan_flow_calibration",
    "extraction_fan_flow_calibration": "extraction_fan_flow_calibration",
    "draft_strat_algo_enabled": "draft_strat_algo_enabled",
    "min_inlet_damper_pos": "min_inlet_damper_pos",
    "max_inlet_damper_pos": "max_inlet_damper_pos",
    "manufacturer_id": "manufacturer_id",
    "manufacturer_phone": "manufacturer_phone",
    "support_id": "support_id",
    "support_phone": "support_phone",
    "udf": "udf",
    "rqf": "rqf",
    "udt": "udt",
    "rqt": "rqt",
    "trt": "trt"
}
